import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import { Badge, Button, Form, Row, Col, Pagination, Table, Spinner } from "react-bootstrap";
import api, { BASE_URL } from "../../Utils/api";
import Modal from "react-bootstrap/Modal";
import { IMaskInput } from "react-imask";
import formatarData from "../../Utils/formatarData";
import {
  parseDDMMYYYYToMySQL,
  dataMaisUmDia,
  diferencaEmDias,
  adicionarDias,
  normalizarDataParaInput,
} from "../../Utils/dateUtils";
import { getDescricaoPeriodicidade } from "../../Utils/dadosAgendamento";
import { GlobalContext } from "../../Utils/GlobalContext";
import validarNumeroInteiro from "../../Utils/ValidarNumeroInteiro";
import validarNumeroDecimal from "../../Utils/ValidarNumeroDecimal";
import validarData from "../../Utils/ValidarData";
import gerarDocumentoPdf from "../../Utils/gerarDocumentoPdf";
import { FaCalendarAlt, FaPrint, FaPaperclip, FaUserFriends, FaClock, FaFileSignature, FaTrash, FaEdit, FaSave, FaCog } from "react-icons/fa";
import { Salvar, Cancelar, ErroModal } from "../Generals";
import { PdfViewerModal } from "../Generals/PdfViewerModal";
import { Data } from "../Generals/Inputs";
import IndicesCorrecaoModal from "../IndicesCorrecao/IndicesCorrecaoModal";
import TiposPagamentoModal from "../TiposPagamento/TiposPagamentoModal";
import TiposDocumentoModal from "../TiposDocumento/TiposDocumentoModal";
import ConfiguracoesCamposModal from "../Configuracoes/ConfiguracoesCampos/ConfiguracoesCamposModal";
import EmpresasModal from "../Empresas/EmpresasModal";
import FuncionariosModal from "../Funcionarios/FuncionariosModal";
import { can } from "../../Utils/controlaPermissao";
import "../../App.css";
import "./DocumentosModal.css";

/** Campos removidos da tabela documentos e de configuracoes_campos — não exibir nem enviar no payload. */
const CAMPOS_REMOVIDOS_DOCUMENTOS = [
  "observacao",
  "vlr_pagamento",
  "url_emissao",
  "usuario",
  "senha",
  "nome_anexo",
  "arquivo_documento",
];
const CAMPOS_ADITIVO_INICIAL = ["dt_inicial", "dt_vencimento"];
const USUARIOS_NOTIFICACAO_ITEMS_PER_PAGE = 10;
const MENSAGEM_SEM_PERMISSAO_RECURSO = "usuário sem permissão para acessar este recurso";

/** Campos aceitos pelo backend em EditarDocumento (PUT) — espelha allowedFields do backend. */
const ALLOWED_FIELDS_EDITAR_DOCUMENTO = [
  "nr_contrato",
  "situacao",
  "id_tipo_documento",
  "id_tipo_pagamento",
  "id_fornecedor",
  "id_indice_correcao",
  "id_empresa",
  "id_usuario_respo",
  "id_usuarios_notificacao",
  "nr_dias_aviso",
  "id_funcionario",
];
// eslint-disable-next-line no-unused-vars
const TIPOS_AGENDAMENTO_ITEMS_PER_PAGE = 10;

const DocumentosModal = ({ show, handleClose, documento, fetchDocumentos }) => {
  
const [formValues, setFormValues] = useState({});
const [definicaoCampos, setDefinicaoCampos] = useState([]);

  /** Evita loop: carregamento do documento completo só roda uma vez por documento.id por abertura do modal. */
  const documentoIdCarregadoRef = useRef(null);
  const { globalData } = useContext(GlobalContext);
  const entidadeID =
    globalData?.entidade_id || localStorage.getItem("entidade_id");
  const idUsuarioLogado = globalData?.user_id || localStorage.getItem("user_id");
  const documentoId = documento?.id;
  const permiteConfigurarTipoDocumento = can(globalData, "tipos_documento");
  const permiteCadastrarTipoPagamento = can(globalData, "tipos_pagamento");
  const permiteCadastrarIndiceCorrecao = can(globalData, "indices_correcao");
  const permiteCadastrarFornecedor = can(globalData, "fornecedores");
  const permiteCadastrarFuncionario = can(globalData, "funcionarios");

  // --------- estados auxiliares ---------
  const [showUsuariosModal, setShowUsuariosModal] = useState(false);
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [usuariosNotificacao, setUsuariosNotificacao] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [listaUsuariosFiltrada, setListaUsuariosFiltrada] = useState([]);
  const [pageAtualUsuarios, setPageAtualUsuarios] = useState(1);
  const [showArquivoModal, setShowArquivoModal] = useState(false);
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [showTipoDocumentoModal, setShowTipoDocumentoModal] = useState(false);
  const idsTiposDocumentoAntesCadastroRef = useRef(new Set());
  const [selectedFile, setSelectedFile] = useState(null);
  const [configuracoesCampos, setConfiguracoesCampos] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [showFornecedorModal, setShowFornecedorModal] = useState(false);
  const idsFornecedoresAntesCadastroRef = useRef(new Set());
  const [usuarioResponsavel, setUsuarioResponsavel] = useState([]);
  const [funcionarios, setFuncionarios] = useState([]);
  const [showFuncionarioModal, setShowFuncionarioModal] = useState(false);
  const idsFuncionariosAntesCadastroRef = useRef(new Set());
  const [tamanhoMaximoArquivoMB, setTamanhoMaximoArquivoMB] = useState(4); // Valor padrão: 4 MB

  const [tiposPagamento, setTiposPagamento] = useState([]);
  const [showTipoPagamentoModal, setShowTipoPagamentoModal] = useState(false);
  const idsTiposPagamentoAntesCadastroRef = useRef(new Set());
  const [indicesCorrecao, setIndicesCorrecao] = useState([]);
  const [showIndiceCorrecaoModal, setShowIndiceCorrecaoModal] = useState(false);
  const idsIndicesAntesCadastroRef = useRef(new Set());
  const [filiais, setFiliais] = useState([]);
  const [erroArquivo, setErroArquivo] = useState(null);
  const [base64File, setBase64File] = useState("");
  const [erroGeral, setErroGeral] = useState(null);
  /** Anexo tratado somente pelo botão Anexo: { nome, path } ou null */
  const [anexoAtual, setAnexoAtual] = useState(null);

  const [showAgendamentosModal, setShowAgendamentosModal] = useState(false);
  const [tiposAgendamentoSelecionados, setTiposAgendamentoSelecionados] =
    useState([]);
  const [agendamentoDetalhes, setAgendamentoDetalhes] = useState([]);
  const [loadingAgendamentos, setLoadingAgendamentos] = useState(false);
  const [pendentesOnly, setPendentesOnly] = useState(true);
  const [agendamentosPage, setAgendamentosPage] = useState(1);
  /** Opções dos campos customizados tipo select: { [nome_campo]: [{ id, valor, ordem }, ...] } */
  const [opcoesCamposCustomizados, setOpcoesCamposCustomizados] = useState({});
  /** Tipo de cada campo customizado vindo do backend (ObterDocumentoCompleto): { [nome_campo]: "numero" | "select" | ... } */
  const [tipoCampoCustomizado, setTipoCampoCustomizado] = useState({});
  const [loadingCampos, setLoadingCampos] = useState(false);

  // Documentos Tipos Agendamento
  const [
    showDocumentosTiposAgendamentoModal,
    setShowDocumentosTiposAgendamentoModal,
  ] = useState(false);
  const [selectedTipoParaAgendamento, setSelectedTipoParaAgendamento] =
    useState(null);
  const [tiposAgendamentoDisponiveis, setTiposAgendamentoDisponiveis] =
    useState([]);
  // Usados no modal "Selecionar Tipos de Agendamento" (IIFE no JSX)
  const [searchTermTiposAgendamento, setSearchTermTiposAgendamento] = useState("");
  const [pageAtualTiposAgendamento, setPageAtualTiposAgendamento] = useState(1);
  const [tiposAgendamentoOriginais, setTiposAgendamentoOriginais] = useState([]);
  const [showConfigCamposModal, setShowConfigCamposModal] = useState(false);
  const [selectedTipoForConfig, setSelectedTipoForConfig] = useState(null);

  const [searchTipoDocumento, setSearchTipoDocumento] = useState("");
  const [dropdownTipoDocumentoOpen, setDropdownTipoDocumentoOpen] = useState(false);
  const tipoDocumentoComboboxRef = useRef(null);

  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [pdfPreviewHtml, setPdfPreviewHtml] = useState(null);
  const [pdfPreviewLoading, setPdfPreviewLoading] = useState(false);
  const pdfIframeRef = useRef(null);

  // Aditivos do documento
  const [showAditivosModal, setShowAditivosModal] = useState(false);
  const [listaAditivos, setListaAditivos] = useState([]);
  const [formAditivo, setFormAditivo] = useState({
    dt_inicial: "",
    dt_vencimento: "",
    nr_dias_aviso: "",
    observacao: "",
    status: "Vigente",
  });
  const [aditivosLoading, setAditivosLoading] = useState(false);
  const [aditivoSalvando, setAditivoSalvando] = useState(false);
  const [erroAditivo, setErroAditivo] = useState(null);
  const [pageAtualAditivos, setPageAtualAditivos] = useState(1);
  const ADITIVOS_ITEMS_PER_PAGE = 3;
  const [aditivoEditando, setAditivoEditando] = useState(null);
  const [showAnexoAditivoModal, setShowAnexoAditivoModal] = useState(false);
  const [aditivoAnexoSelecionado, setAditivoAnexoSelecionado] = useState(null);
  const [selectedFileAditivo, setSelectedFileAditivo] = useState(null);
  const [erroArquivoAditivo, setErroArquivoAditivo] = useState(null);
  const [anexoAditivoUploading, setAnexoAditivoUploading] = useState(false);
  const [selectedFileNovoAditivo, setSelectedFileNovoAditivo] = useState(null);
  const inputFileNovoAditivoRef = useRef(null);
  const [pdfViewerAnexo, setPdfViewerAnexo] = useState({
    show: false,
    documentoId: null,
    aditivoId: null,
    title: "",
  });

  const fecharVisualizadorPdf = () => {
    setPdfViewerAnexo({ show: false, documentoId: null, aditivoId: null, title: "" });
  };

  const handleExcluirAnexoVisualizador = async () => {
    const token = localStorage.getItem("authToken");
    if (pdfViewerAnexo.aditivoId) {
      await api.put(
        `${BASE_URL}/api/documentos/EditarAditivo/${pdfViewerAnexo.aditivoId}`,
        { arquivo_documento: null, nome_anexo: null },
        {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      fecharVisualizadorPdf();
      await fetchAditivosDocumento(documento.id);
      if (showAnexoAditivoModal) handleCloseAnexoAditivoModal();
    } else if (pdfViewerAnexo.documentoId) {
      await editarAnexo(pdfViewerAnexo.documentoId, null, true);
      fecharVisualizadorPdf();
      setAnexoAtual(null);
      setBase64File("");
    }
  };

  const obterTituloAnexoDocumento = useCallback(() => {
    const aditivoComArquivo = [...listaAditivos]
      .filter((a) => a.nome_anexo || a.arquivo_documento)
      .sort((a, b) => (b.numero_aditivo || 0) - (a.numero_aditivo || 0))[0];
    if (aditivoComArquivo?.nome_anexo) return aditivoComArquivo.nome_anexo;
    return anexoAtual?.nome || "Visualizar PDF";
  }, [listaAditivos, anexoAtual]);

  const documentoTemAnexo = useCallback(() => {
    if (listaAditivos.some((a) => a.nome_anexo || a.arquivo_documento)) return true;
    return Boolean(anexoAtual?.nome);
  }, [listaAditivos, anexoAtual]);

  const abrirVisualizadorPdfDocumento = () => {
    if (!documento?.id) return;
    setPdfViewerAnexo({
      show: true,
      documentoId: documento.id,
      aditivoId: null,
      title: obterTituloAnexoDocumento(),
    });
  };

  const abrirVisualizadorPdfAditivo = (aditivo) => {
    if (!aditivo?.id || !(aditivo?.tem_anexo || aditivo?.arquivo_documento)) return;
    setPdfViewerAnexo({
      show: true,
      documentoId: null,
      aditivoId: aditivo.id,
      title: aditivo.nome_anexo || "Visualizar PDF",
    });
  };

  const handleClickAnexo = () => {
    if (documento?.id && documentoTemAnexo()) {
      abrirVisualizadorPdfDocumento();
      return;
    }
    setShowArquivoModal(true);
  };

  const handlePrint = async () => {
    if (!documento?.id) {
      alert("Salve o documento antes de imprimir.");
      return;
    }
    setPdfPreviewLoading(true);
    setPdfPreviewHtml(null);
    setShowPdfPreview(true);
    try {
      const html = await gerarDocumentoPdf(documento, {
        nomeEntidade: globalData?.nome_entidade ?? null,
        logotipo: globalData?.logotipo ?? null,
        usuario: globalData?.user ?? null,
      });
      if (!html) {
        alert("Sem dados para exibir!");
        return;
      }
      setPdfPreviewHtml(html);
    } finally {
      setPdfPreviewLoading(false);
    }
  };

  const resetForm = useCallback(() => {
    if (definicaoCampos.length > 0) {
      const valoresIniciais = { situacao: "V" };
      definicaoCampos.forEach((campo) => {
        if (!CAMPOS_REMOVIDOS_DOCUMENTOS.includes(campo.nome)) {
          valoresIniciais[campo.nome] = campo.nome === "situacao" ? "V" : campo.default;
        }
      });
      setFormValues(valoresIniciais);
    }
  }, [definicaoCampos]);

  // --------- fetchers memorizados ---------
  const fetchUsuarioResponsavel = useCallback(async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/usuarios/ListarUsuarioResponsavel/${entidadeID}`
      );
      setUsuarioResponsavel(data.data);
    } catch (error) {
      console.error("Erro ao buscar usuário responsável:", error);
    }
  }, [entidadeID]);

  const fetchUsuariosNotificacao = useCallback(async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/usuarios/ListarUsuariosNotificacao/${entidadeID}`
      );
      setListaUsuarios(data.data);
      setListaUsuariosFiltrada(data.data);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
    }
  }, [entidadeID]);

  const abrirCadastroTipoPagamento = useCallback(() => {
    if (!permiteCadastrarTipoPagamento) return;
    idsTiposPagamentoAntesCadastroRef.current = new Set(
      tiposPagamento.map((tipo) => String(tipo.id))
    );
    setShowTipoPagamentoModal(true);
  }, [permiteCadastrarTipoPagamento, tiposPagamento]);

  const recarregarTiposPagamento = useCallback(async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/tiposPagamento/ListarTiposPagamento/${entidadeID}`
      );
      const tipos = Array.isArray(data?.data) ? data.data : [];
      setTiposPagamento(tipos);
      if (tipos.length > 0) {
        const tipoNovo = tipos.find(
          (tipo) => !idsTiposPagamentoAntesCadastroRef.current.has(String(tipo.id))
        );
        setFormValues((prevValues) => {
          const idParaSelecionar = tipoNovo?.id ?? (!prevValues.id_tipo_pagamento ? tipos[0].id : null);
          return idParaSelecionar == null
            ? prevValues
            : { ...prevValues, id_tipo_pagamento: String(idParaSelecionar) };
        });
        idsTiposPagamentoAntesCadastroRef.current = new Set(
          tipos.map((tipo) => String(tipo.id))
        );
      }
    } catch (error) {
      console.error("Erro ao buscar tipos de pagamento:", error);
      setTiposPagamento([]);
    }
  }, [entidadeID]);

  const abrirCadastroIndiceCorrecao = useCallback(() => {
    if (!permiteCadastrarIndiceCorrecao) return;
    idsIndicesAntesCadastroRef.current = new Set(
      indicesCorrecao.map((indice) => String(indice.id))
    );
    setShowIndiceCorrecaoModal(true);
  }, [indicesCorrecao, permiteCadastrarIndiceCorrecao]);

  const recarregarIndicesCorrecao = useCallback(async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/indicesCorrecao/ListarIndicesCorrecao/${entidadeID}`
      );
      const indices = Array.isArray(data?.data) ? data.data : [];
      setIndicesCorrecao(indices);
      if (indices.length > 0) {
        const indiceNovo = indices.find(
          (indice) => !idsIndicesAntesCadastroRef.current.has(String(indice.id))
        );
        setFormValues((prevValues) => {
          const idParaSelecionar = indiceNovo?.id ?? (!prevValues.id_indice_correcao ? indices[0].id : null);
          return idParaSelecionar == null
            ? prevValues
            : { ...prevValues, id_indice_correcao: String(idParaSelecionar) };
        });
        idsIndicesAntesCadastroRef.current = new Set(
          indices.map((indice) => String(indice.id))
        );
      }
    } catch (error) {
      console.error("Erro ao buscar indices de correcao:", error);
      setIndicesCorrecao([]);
    }
  }, [entidadeID]);

  const fetchFuncionarios = useCallback(async (idFornecedor = null) => {
    if (!idFornecedor) {
      setFuncionarios([]);
      return [];
    }
    if (!entidadeID) {
      setFuncionarios([]);
      return [];
    }
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/funcionarios/ListarFuncionarios/${entidadeID}?id_empresa=${idFornecedor}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );
      const lista = Array.isArray(data?.data) ? data.data : [];
      setFuncionarios(lista);
      return lista;
    } catch (error) {
      console.error("Erro ao buscar funcionários:", error);
      setFuncionarios([]);
    }
  }, [entidadeID]);

  const abrirCadastroFornecedor = useCallback(() => {
    if (!permiteCadastrarFornecedor) return;
    idsFornecedoresAntesCadastroRef.current = new Set(
      fornecedores.map((fornecedor) => String(fornecedor.id))
    );
    setShowFornecedorModal(true);
  }, [fornecedores, permiteCadastrarFornecedor]);

  const recarregarFornecedores = useCallback(async (idFornecedorPreferencial = null) => {
    if (!entidadeID) {
      setFornecedores([]);
      return;
    }
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/empresas/ListarFornecedoresAtivos/${entidadeID}`
      );
      const fornecedoresAtivos = Array.isArray(data?.data) ? data.data : [];
      setFornecedores(fornecedoresAtivos);
      if (fornecedoresAtivos.length > 0) {
        const fornecedorNovo = fornecedoresAtivos.find(
          (fornecedor) => !idsFornecedoresAntesCadastroRef.current.has(String(fornecedor.id))
        );
        const idParaSelecionar = idFornecedorPreferencial ?? fornecedorNovo?.id;
        if (idParaSelecionar != null) {
          setFormValues((prevValues) => ({
            ...prevValues,
            id_fornecedor: String(idParaSelecionar),
            id_funcionario: "",
          }));
          fetchFuncionarios(String(idParaSelecionar));
        } else {
          setFormValues((prevValues) => {
            if (prevValues.id_fornecedor) return prevValues;
            const primeiroFornecedorId = fornecedoresAtivos[0]?.id;
            if (primeiroFornecedorId == null) return prevValues;
            fetchFuncionarios(String(primeiroFornecedorId));
            return {
              ...prevValues,
              id_fornecedor: String(primeiroFornecedorId),
              id_funcionario: "",
            };
          });
        }
        idsFornecedoresAntesCadastroRef.current = new Set(
          fornecedoresAtivos.map((fornecedor) => String(fornecedor.id))
        );
      }
    } catch (error) {
      console.error("Erro ao buscar fornecedores:", error);
      setFornecedores([]);
    }
  }, [entidadeID, fetchFuncionarios]);

  const handleCloseFornecedorModal = useCallback(
    async (resultado) => {
      setShowFornecedorModal(false);
      await recarregarFornecedores(resultado?.id ? String(resultado.id) : null);
    },
    [recarregarFornecedores]
  );

  const abrirCadastroFuncionario = useCallback(() => {
    if (!permiteCadastrarFuncionario || !formValues.id_fornecedor) return;
    idsFuncionariosAntesCadastroRef.current = new Set(
      funcionarios.map((funcionario) => String(funcionario.id))
    );
    setShowFuncionarioModal(true);
  }, [formValues.id_fornecedor, funcionarios, permiteCadastrarFuncionario]);

  const recarregarFuncionarios = useCallback(async () => {
    if (!formValues.id_fornecedor) {
      setFuncionarios([]);
      return;
    }
    const lista = (await fetchFuncionarios(formValues.id_fornecedor)) || [];
    if (lista.length > 0) {
      const funcionarioNovo = lista.find(
        (funcionario) => !idsFuncionariosAntesCadastroRef.current.has(String(funcionario.id))
      );
      const idParaSelecionar =
        funcionarioNovo?.id ?? (!formValues.id_funcionario ? lista[0].id : null);
      if (idParaSelecionar != null) {
        setFormValues((prevValues) => ({
          ...prevValues,
          id_funcionario: String(idParaSelecionar),
        }));
      }
      idsFuncionariosAntesCadastroRef.current = new Set(
        lista.map((funcionario) => String(funcionario.id))
      );
    }
  }, [fetchFuncionarios, formValues.id_fornecedor, formValues.id_funcionario]);

  // --------- helpers ---------
  /** Indica se o campo de configuração é customizado (persistido em campos_customizados_respostas, não na tabela documentos). */
  const isCampoCustomizado = (campoConfig) => {
    if (!campoConfig) return false;
    if (campoConfig.id_campo_customizado != null && campoConfig.id_campo_customizado !== "") return true;
    const nome = String(campoConfig.nome_campo || "").trim();
    return nome.startsWith("customizada_");
  };

  /** Normaliza item da rota CamposCustomizadosPorTipoDocumento para o formato usado pelo modal (tipo_campo, obrigatorio/visivel "S"/"N"). */
  const normalizarCampoCustomizado = (item) => {
    const obrigatorio = item.obrigatorio === true || item.obrigatorio === "S" || item.obrigatorio === "s" ? "S" : "N";
    const visivel = item.visivel !== false && item.visivel !== "N" && item.visivel !== "n" ? "S" : "N";
    return {
      nome_campo: item.nome_campo,
      tipo_campo: item.tipo || item.tipo_campo,
      descricao: item.descricao,
      obrigatorio,
      visivel,
      ordem: item.ordem != null ? Number(item.ordem) : 0,
      origem: item.origem || "C",
      ...(Array.isArray(item.opcoes) && item.opcoes.length > 0 ? { opcoes: item.opcoes } : {}),
    };
  };

  /** idEntidadeOuEmpresa: quando informado (ex.: empresa selecionada), usa na URL; senão usa entidadeID do contexto. */
  const fetchCamposConfigurados = async (id_tipo_documento, idEntidadeOuEmpresa) => {
    if (!id_tipo_documento) {
      setConfiguracoesCampos([]);
      setOpcoesCamposCustomizados((prev) => ({}));
      return;
    }
    const authHeader = { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } };
    const idEntidade = idEntidadeOuEmpresa || entidadeID;
    try {
      // Campos fixos (configuração da tabela documentos por tipo)
      const resConfig = await api.get(
        `${BASE_URL}/api/configuracaoCampos/ListarConfiguracoesCamposPorTipoDocumentos/${id_tipo_documento}`,
        authHeader
      );
      const camposFixos = Array.isArray(resConfig.data?.data) ? resConfig.data.data : [];
      const apenasFixos = camposFixos.filter(
        (c) => !String(c.nome_campo || "").trim().startsWith("customizada_")
      );
      const camposFixosComDatas = (() => {
        if (documento?.id) return apenasFixos;
        const existentes = new Set(apenasFixos.map((c) => c.nome_campo));
        const ordemBase = Number(apenasFixos.find((c) => c.nome_campo === "nr_contrato")?.ordem) || 1;
        const extras = [];
        if (!existentes.has("dt_inicial")) {
          extras.push({
            nome_campo: "dt_inicial",
            descricao: "Data inicial",
            visivel: "S",
            obrigatorio: "S",
            ordem: ordemBase + 0.1,
            origem: "P",
          });
        }
        if (!existentes.has("dt_vencimento")) {
          extras.push({
            nome_campo: "dt_vencimento",
            descricao: "Data final",
            visivel: "S",
            obrigatorio: "S",
            ordem: ordemBase + 0.2,
            origem: "P",
          });
        }
        return [...apenasFixos, ...extras].map((campo) =>
          CAMPOS_ADITIVO_INICIAL.includes(campo.nome_campo)
            ? { ...campo, obrigatorio: "S" }
            : campo
        );
      })();

      // Campos customizados: ListarCamposPorTipoDocumento(idEntidade, idTipoDocumento)
      let customizados = [];
      if (idEntidade) {
        const urlListarCampos = `${BASE_URL}/api/camposCustomizados/ListarCamposPorTipoDocumento/${idEntidade}/${id_tipo_documento}`;
        try {
          const resCustom = await api.get(urlListarCampos, authHeader);
          customizados = Array.isArray(resCustom.data?.data) ? resCustom.data.data : [];
        } catch (errCustom) {
          console.warn("ListarCamposPorTipoDocumento falhou, tentando CamposCustomizadosPorTipoDocumento:", errCustom?.response?.status);
          const resFallback = await api.get(
            `${BASE_URL}/api/documentos/CamposCustomizadosPorTipoDocumento/${id_tipo_documento}`,
            authHeader
          );
          customizados = Array.isArray(resFallback.data?.data) ? resFallback.data.data : [];
        }
      } else {
        const resFallback = await api.get(
          `${BASE_URL}/api/documentos/CamposCustomizadosPorTipoDocumento/${id_tipo_documento}`,
          authHeader
        );
        customizados = Array.isArray(resFallback.data?.data) ? resFallback.data.data : [];
      }

      const customNormalizados = customizados.map(normalizarCampoCustomizado);
      const merged = [...camposFixosComDatas, ...customNormalizados].sort(
        (a, b) => (Number(a.ordem) ?? 0) - (Number(b.ordem) ?? 0)
      );
      setConfiguracoesCampos(merged);
      const opcoesByCampo = {};
      customNormalizados.forEach((c) => {
        if ((c.tipo_campo || "").toString().toLowerCase() === "cadastro" && Array.isArray(c.opcoes) && c.opcoes.length > 0) {
          opcoesByCampo[c.nome_campo] = c.opcoes.slice().sort((a, b) => (Number(a.ordem) || 0) - (Number(b.ordem) || 0));
        }
      });
      setOpcoesCamposCustomizados((prev) => ({ ...prev, ...opcoesByCampo }));
    } catch (error) {
      console.error("Erro ao buscar campos configurados / customizados:", error);
      setConfiguracoesCampos([]);
      setOpcoesCamposCustomizados((prev) => ({}));
    }
  };

  /** Busca documento completo (incluindo campos_customizados) para edição — usa rota ObterDocumentoCompleto (documentos.js). */
  const obterTipoDocumentoSelecionado = useCallback(() => {
    const idTipoDocumento = formValues.id_tipo_documento || documento?.id_tipo_documento;
    if (!idTipoDocumento) return null;
    const tipo = tiposDocumento.find((item) => String(item.id) === String(idTipoDocumento));
    return {
      ...(tipo || {}),
      id: idTipoDocumento,
      nome:
        tipo?.nome ||
        documento?.tipo_documento ||
        documento?.nome_tipo_documento ||
        `Tipo ${idTipoDocumento}`,
    };
  }, [documento, formValues.id_tipo_documento, tiposDocumento]);

  const resolverTipoConfiguracaoId = useCallback(async (idTipoDocumento) => {
    if (!entidadeID || !idTipoDocumento) return null;
    try {
      const token = localStorage.getItem("authToken");
      const { data } = await api.get(
        `${BASE_URL}/api/configuracaoCampos/ListarTiposConfiguracoesCampos/${entidadeID}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      const lista = Array.isArray(data?.data) ? data.data : [];
      const match = lista.find((item) => Number(item.id_tipo_documento) === Number(idTipoDocumento));
      return match?.id ?? null;
    } catch (error) {
      console.error("Erro ao resolver configuracao de campos do tipo de documento:", error);
      return null;
    }
  }, [entidadeID]);

  const handleOpenConfigCamposTipoDocumento = async () => {
    if (!permiteConfigurarTipoDocumento) return;
    const tipoDocumento = obterTipoDocumentoSelecionado();
    if (!tipoDocumento?.id) return;
    const idConfig = await resolverTipoConfiguracaoId(tipoDocumento.id);
    if (idConfig != null) {
      setSelectedTipoForConfig({
        ...tipoDocumento,
        id: idConfig,
        id_tipo_documento: tipoDocumento.id,
      });
      setShowConfigCamposModal(true);
    } else {
      setErroGeral("Configuracao de campos nao encontrada para este tipo de documento.");
    }
  };

  const handleCloseConfigCamposTipoDocumento = () => {
    setShowConfigCamposModal(false);
    setSelectedTipoForConfig(null);
    if (formValues.id_tipo_documento && formValues.id_empresa) {
      fetchCamposConfigurados(formValues.id_tipo_documento, formValues.id_empresa);
    }
  };

  const fetchDocumentoCompleto = useCallback(async (idDocumento) => {
    if (!idDocumento) return null;
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/documentos/ObterDocumentoCompleto/${idDocumento}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );
      return data.data;
    } catch (error) {
      console.error("Erro ao buscar documento completo:", error);
      return null;
    }
  }, []);

  const selectTipoDocumentoById = (id) => {
    const selectedTipoDocumento = id || "";
    setFormValues((prevValues) => {
      const next = { ...prevValues, id_tipo_documento: selectedTipoDocumento };
      // Auto-preenche tipo de pagamento somente em novo documento e se o tipo tiver padrão
      if (!documento && selectedTipoDocumento && !prevValues.id_tipo_pagamento) {
        const tipo = tiposDocumento.find((t) => String(t.id) === String(selectedTipoDocumento));
        if (tipo?.id_tipo_pagamento_padrao) {
          next.id_tipo_pagamento = tipo.id_tipo_pagamento_padrao;
        }
      }
      return next;
    });
    if (selectedTipoDocumento) {
      // Usa empresa já selecionada se houver; senão entidadeID (dentro de fetchCamposConfigurados)
      fetchCamposConfigurados(selectedTipoDocumento);
    } else {
      setConfiguracoesCampos([]);
    }
    setSearchTipoDocumento("");
    setDropdownTipoDocumentoOpen(false);
  };

  const recarregarTiposDocumento = useCallback(async (idTipoDocumentoPreferencial = null, selecionarCriado = false) => {
    if (!entidadeID) {
      setTiposDocumento([]);
      return [];
    }
    try {
      const userParam = idUsuarioLogado ? `?userId=${idUsuarioLogado}` : "";
      const { data } = await api.get(
        `${BASE_URL}/api/tiposDocumento/ListarTiposDocumento/${entidadeID}${userParam}`
      );
      const tipos = Array.isArray(data?.data) ? data.data : [];
      setTiposDocumento(tipos);

      const tipoNovo = selecionarCriado
        ? tipos.find((tipo) => !idsTiposDocumentoAntesCadastroRef.current.has(String(tipo.id)))
        : null;
      const idParaSelecionar = idTipoDocumentoPreferencial ?? tipoNovo?.id;
      if (idParaSelecionar != null) {
        selectTipoDocumentoById(idParaSelecionar);
      }

      idsTiposDocumentoAntesCadastroRef.current = new Set(
        tipos.map((tipo) => String(tipo.id))
      );
      return tipos;
    } catch (error) {
      console.error("Erro ao buscar tipos de documento:", error);
      setTiposDocumento([]);
      return [];
    }
  // selectTipoDocumentoById usa o estado atual do modal e nao precisa reexecutar este fetcher a cada render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entidadeID, idUsuarioLogado]);

  const abrirCadastroTipoDocumento = useCallback(() => {
    if (!permiteConfigurarTipoDocumento) return;
    idsTiposDocumentoAntesCadastroRef.current = new Set(
      tiposDocumento.map((tipo) => String(tipo.id))
    );
    setShowTipoDocumentoModal(true);
  }, [permiteConfigurarTipoDocumento, tiposDocumento]);

  const handleCloseTipoDocumentoModal = useCallback(
    async (resultado) => {
      setShowTipoDocumentoModal(false);
      const idCriado = resultado?.id || resultado?.id_tipo_documento;
      await recarregarTiposDocumento(idCriado != null ? String(idCriado) : null, true);
    },
    [recarregarTiposDocumento]
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (tipoDocumentoComboboxRef.current && !tipoDocumentoComboboxRef.current.contains(e.target)) {
        setDropdownTipoDocumentoOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const inserirAnexo = async (documentoId, arquivoBase64, nomeArquivo) => {
    const url = `${BASE_URL}/api/documentos/InserirAnexo/${documentoId}`;
    const payload = {
      arquivo_base64: `data:application/pdf;base64,${arquivoBase64}`,
      nome_arquivo: nomeArquivo,
    };
    try {
      const response = await api.post(url, payload, {
        headers: { 'Content-Type': 'application/json' }
      });
      return response;
    } catch (error) {
      console.error("Erro na requisição de anexo:", error?.response?.data || error?.message);
      throw error;
    }
  };

  const editarAnexo = async (
    documentoId,
    arquivoBase64 = null,
    remover = false,
    nomeArquivo = null
  ) => {
    return api.put(`${BASE_URL}/api/documentos/EditarAnexo/${documentoId}`, {
      ...(arquivoBase64 && {
        arquivo_base64: `data:application/pdf;base64,${arquivoBase64}`,
      }),
      ...(nomeArquivo && { nome_arquivo: nomeArquivo }),
      ...(remover && { remover_anexo: true }),
    });
  };

  const inserirAnexoAditivo = async (idAditivo, arquivo) => {
    const url = `${BASE_URL}/api/documentos/InserirAnexoAditivo/${idAditivo}`;
    const formData = new FormData();
    formData.append("arquivo", arquivo);
    const token = localStorage.getItem("authToken");
    const { data } = await api.post(url, formData, {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // não definir Content-Type; o browser define com boundary para multipart/form-data
      },
    });
    return data;
  };

/** JSON dos campos obrigatórios (para log e exibição na montagem). */
  const camposObrigatoriosJson = React.useMemo(() => {
    const lista = (configuracoesCampos || [])
      .filter((c) => c.obrigatorio === "S")
      .map((c) => ({ nome_campo: c.nome_campo, descricao: c.descricao || c.nome_campo, obrigatorio: c.obrigatorio }));
    return lista;
  }, [configuracoesCampos]);

  React.useEffect(() => {
    if (camposObrigatoriosJson.length > 0) {
      //console.log("[DocumentosModal] Campos obrigatórios (montagem):", JSON.stringify(camposObrigatoriosJson, null, 2));
    }
  }, [camposObrigatoriosJson]);

  const verificarCamposObrigatorios = () => {
  const faltantes = [];
  const temArquivoAnexado = anexoAtual != null;
  const temArquivoNovo = selectedFile && base64File;

  configuracoesCampos.forEach((campoConfig) => {
    const { nome_campo, obrigatorio, descricao } = campoConfig;

    if (CAMPOS_REMOVIDOS_DOCUMENTOS.includes(nome_campo)) {
      if (obrigatorio === "S" && !temArquivoAnexado && !temArquivoNovo) {
        faltantes.push(descricao || "Arquivo");
      }
      return;
    }

    const valor = formValues[nome_campo];
    let vazio =
      valor === undefined ||
      valor === null ||
      (typeof valor === "string" && valor.trim() === "") ||
      (typeof valor !== "string" && !valor);
    // Situação: valor exibido no Select é "V" (Vigente) por padrão; se o usuário não alterar, formValues.situacao pode vir vazio
    if (nome_campo === "situacao" && vazio) {
      vazio = false; // considera preenchido com o default Vigente (V)
    }

    if (obrigatorio === "S" && vazio) {
      faltantes.push(descricao || nome_campo);
    }
  });

  return faltantes;
};


  const handleSave = async () => {
    setErroGeral(null);

    if (!documento) {
      const idTipo = formValues.id_tipo_documento;
      if (idTipo === undefined || idTipo === null || String(idTipo).trim() === "") {
        setErroGeral("Selecione o tipo de documento.");
        return;
      }
    }

    // valida campos obrigatórios (mensagem exibida no próprio modal via erroGeral)
    const faltantes = verificarCamposObrigatorios();
    if (faltantes.length > 0) {
      setErroGeral("Os seguintes campos obrigatórios não foram preenchidos: " + faltantes.join(", ") + ".");
      return;
    }

    // valida campos customizados tipo numero: devem ser inteiros (usa tipo do backend + configuracoesCampos)
    const nomesNumeroConfig = (configuracoesCampos || [])
      .filter((c) => isCampoCustomizado(c) && ["numero", "inteiro"].includes(String(c.tipo_campo || c.tipo || "").toLowerCase()))
      .map((c) => c.nome_campo);
    const nomesNumeroBackend = Object.entries(tipoCampoCustomizado || {})
      .filter(([, tipo]) => tipo === "numero" || tipo === "inteiro")
      .map(([nome]) => nome);
    const todosNomesNumero = [...new Set([...nomesNumeroConfig, ...nomesNumeroBackend])];
    const camposConfigMap = (configuracoesCampos || []).reduce((acc, c) => { acc[c.nome_campo] = c; return acc; }, {});
    for (const nomeCampo of todosNomesNumero) {
      const val = formValues[nomeCampo];
      if (!validarNumeroInteiro(val)) {
        const label = (camposConfigMap[nomeCampo] && (camposConfigMap[nomeCampo].descricao || camposConfigMap[nomeCampo].nome_campo)) || nomeCampo || "Campo";
        setErroGeral(`O campo "${label}" deve ser um número inteiro (sem vírgula ou casas decimais).`);
        return;
      }
    }

    // valida campos customizados tipo Decimal: devem ser número (inteiro ou decimal)
    const nomesDecimalConfig = (configuracoesCampos || [])
      .filter((c) => isCampoCustomizado(c) && ["decimal", "valor"].includes(String(c.tipo_campo || c.tipo || "").toLowerCase()))
      .map((c) => c.nome_campo);
    const nomesDecimalBackend = Object.entries(tipoCampoCustomizado || {})
      .filter(([, t]) => (String(t).toLowerCase() === "decimal" || String(t).toLowerCase() === "valor"))
      .map(([nome]) => nome);
    const todosNomesDecimal = [...new Set([...nomesDecimalConfig, ...nomesDecimalBackend])];
    for (const nomeCampo of todosNomesDecimal) {
      const val = formValues[nomeCampo];
      if (!validarNumeroDecimal(val)) {
        const label = (camposConfigMap[nomeCampo] && (camposConfigMap[nomeCampo].descricao || camposConfigMap[nomeCampo].nome_campo)) || nomeCampo || "Campo";
        setErroGeral(`O campo "${label}" deve ser um número decimal válido.`);
        return;
      }
    }

    // valida campos customizados tipo Data: devem ser data válida dd/MM/yyyy (ou vazio)
    const nomesDataConfig = (configuracoesCampos || [])
      .filter((c) => isCampoCustomizado(c) && String(c.tipo_campo || c.tipo || "").toLowerCase() === "data")
      .map((c) => c.nome_campo);
    const nomesDataBackend = Object.entries(tipoCampoCustomizado || {})
      .filter(([, t]) => String(t).toLowerCase() === "data")
      .map(([nome]) => nome);
    const todosNomesData = [...new Set([...nomesDataConfig, ...nomesDataBackend])];
    for (const nomeCampo of todosNomesData) {
      const val = formValues[nomeCampo];
      if (!validarData(val)) {
        const label = (camposConfigMap[nomeCampo] && (camposConfigMap[nomeCampo].descricao || camposConfigMap[nomeCampo].nome_campo)) || nomeCampo || "Campo";
        setErroGeral(`O campo "${label}" deve ser uma data válida no formato dd/MM/yyyy.`);
        return;
      }
    }

    try {
      // Campos da tabela documentos (definidos em definicaoCampos); customizados vão para campos_customizados_respostas
      // Fallback para formValues quando definicaoCampos ainda não foi carregado (corrida de carregamento)
      const nomesColunasDocumento = (definicaoCampos || []).length > 0
        ? (definicaoCampos || []).filter((c) => !CAMPOS_REMOVIDOS_DOCUMENTOS.includes(c.nome)).map((c) => c.nome)
        : Object.keys(formValues).filter((k) => !CAMPOS_REMOVIDOS_DOCUMENTOS.includes(k));
      const payload = {};
      nomesColunasDocumento.forEach((key) => {
        if (formValues[key] !== undefined) payload[key] = formValues[key];
      });
      // Situação: default Vigente (V) quando o usuário não alterou o campo
      if (payload.situacao === undefined || payload.situacao === null || String(payload.situacao).trim() === "") {
        payload.situacao = "V";
      }
      if (!documento) {
        if (formValues.id_tipo_documento !== undefined && formValues.id_tipo_documento !== null && String(formValues.id_tipo_documento).trim() !== "") {
          payload.id_tipo_documento = formValues.id_tipo_documento;
        }
        if (formValues.id_empresa !== undefined && formValues.id_empresa !== null && String(formValues.id_empresa).trim() !== "") {
          payload.id_empresa = formValues.id_empresa;
        }
        // Datas e usuário do período inicial — armazenados em documentos_aditivo pelo backend
        if (formValues.dt_inicial)    payload.dt_inicial    = formValues.dt_inicial;
        if (formValues.dt_vencimento) payload.dt_vencimento = formValues.dt_vencimento;
        if (idUsuarioLogado)          payload.id_usuario    = idUsuarioLogado;
      }

      const temArquivoNovo = selectedFile && base64File;
      const temArquivoAnexado = anexoAtual != null;

      if (temArquivoNovo) {
        if (!base64File || base64File.length === 0) {
          setErroGeral("Erro: arquivo não foi processado corretamente. Tente selecionar o arquivo novamente.");
          return;
        }
        if (!selectedFile?.name) {
          setErroGeral("Erro: nome do arquivo não encontrado. Tente selecionar o arquivo novamente.");
          return;
        }
        payload.arquivo_base64 = `data:application/pdf;base64,${base64File}`;
        payload.nome_anexo = selectedFile.name;
      } else if (temArquivoAnexado) {
        if (anexoAtual.path) payload.arquivo_documento = anexoAtual.path;
        if (anexoAtual.nome) payload.nome_anexo = anexoAtual.nome;
      } else {
        delete payload.arquivo_base64;
      }

      const campoArquivoObrigatorio = configuracoesCampos.find(
        (c) => c.nome_campo === "arquivo_documento" && c.obrigatorio === "S"
      );
      if (campoArquivoObrigatorio && !temArquivoNovo && !temArquivoAnexado) {
        const mensagem = campoArquivoObrigatorio.descricao || "Arquivo é obrigatório";
        setErroGeral(mensagem);
        return;
      }

      // Campos customizados: backend documentos.js espera campos_customizados no body (array { nome_campo, valor })
      const campos_customizados = (configuracoesCampos || [])
        .filter(isCampoCustomizado)
        .map((c) => {
          let valor = formValues[c.nome_campo];
          const tipo = String(c.tipo_campo || c.tipo || tipoCampoCustomizado[c.nome_campo] || "").toLowerCase();
          if (tipo === "data" && valor != null && valor !== "") {
            valor = normalizarDataParaInput(String(valor));
          } else if (tipo === "decimal" || tipo === "valor") {
            if (valor != null && valor !== "") {
              valor = String(valor).replace(".", ",");
            } else {
              valor = "";
            }
          } else if (valor != null && valor !== "") {
            valor = typeof valor === "number" ? valor : String(valor);
          } else {
            valor = "";
          }
          return { nome_campo: c.nome_campo, valor };
        });
      if (campos_customizados.length > 0) payload.campos_customizados = campos_customizados;

      // EditarDocumento (PUT): backend aceita apenas allowedFields + campos_customizados; id, arquivo_base64, nome_anexo, arquivo_documento são removidos no backend
      if (documento) {
        const payloadEdit = {};
        ALLOWED_FIELDS_EDITAR_DOCUMENTO.forEach((k) => {
          if (payload[k] !== undefined) payloadEdit[k] = payload[k];
        });
        if (payload.campos_customizados && payload.campos_customizados.length > 0) {
          payloadEdit.campos_customizados = payload.campos_customizados;
        }
        Object.keys(payload).forEach((k) => delete payload[k]);
        Object.assign(payload, payloadEdit);
      }

      // JSON enviado ao backend (para log: base64 do arquivo abreviado)
      const payloadParaLog = { ...payload };
      if (payloadParaLog.arquivo_base64) {
        payloadParaLog.arquivo_base64 = `[Base64 PDF - ${(payload.arquivo_base64 || "").length} caracteres]`;
      }
      //console.log("[DocumentosModal] Salvar documento — JSON enviado ao backend:", JSON.stringify(payloadParaLog, null, 2));

      const url = documento
        ? `${BASE_URL}/api/documentos/EditarDocumento/${documento.id}`
        : `${BASE_URL}/api/documentos/InserirDocumento`;

      // Se houver arquivo novo, envia como FormData (multipart/form-data)
      if (temArquivoNovo && selectedFile) {
        const formData = new FormData();
        formData.append("arquivo", selectedFile);
        Object.keys(payload).forEach((key) => {
          if (key !== "arquivo_base64" && !CAMPOS_REMOVIDOS_DOCUMENTOS.includes(key)) {
            if (payload[key] !== undefined && payload[key] !== null && payload[key] !== "") {
              const value = typeof payload[key] === "object" ? JSON.stringify(payload[key]) : payload[key];
              formData.append(key, value);
            }
          }
        });
        if (selectedFile.name) formData.append("nome_anexo", selectedFile.name);
        if (documento) {
          await api.put(url, formData);
        } else {
          await api.post(url, formData);
        }
      } else {
        if (documento) {
          await api.put(url, payload, { headers: { "Content-Type": "application/json" } });
        } else {
          await api.post(url, payload, { headers: { "Content-Type": "application/json" } });
        }
      }

//      console.log("✅ Documento salvo com sucesso — JSON enviado:", JSON.stringify(payloadParaLog, null, 2));
      fetchDocumentos();
      handleClose();
    } catch (err) {
      console.error("❌ Erro ao salvar documento:", err);
      console.error("📋 Detalhes completos do erro:", {
        message: err?.message,
        response: err?.response?.data,
        status: err?.response?.status,
        statusText: err?.response?.statusText,
        url: err?.config?.url,
        method: err?.config?.method,
        headers: err?.config?.headers
      });
      
      // Tenta extrair a mensagem de erro do backend de diferentes formatos
      let errorMessage = "Erro ao salvar documento.";
      
      if (err?.response?.data) {
        if (typeof err.response.data === 'string') {
          errorMessage = err.response.data;
        } else if (err.response.data.message) {
          errorMessage = err.response.data.message;
        } else if (err.response.data.error) {
          errorMessage = err.response.data.error;
        } else if (err.response.data.erro) {
          errorMessage = err.response.data.erro;
        } else if (err.response.data.sqlMessage) {
          errorMessage = `Erro no banco de dados: ${err.response.data.sqlMessage}`;
        }
      } else if (err?.message) {
        errorMessage = err.message;
      }
      
      console.error("💬 Mensagem de erro extraída:", errorMessage);
      setErroGeral(errorMessage);
    }
  };

  const handleEmpresaChange = (e) => {
    const empresaId = e.target.value;
    setFormValues((prevValues) => ({
      ...prevValues,
      id_empresa: empresaId,
      id_funcionario: "",
    }));
    if (empresaId) {
      if (formValues.id_tipo_documento) {
        fetchCamposConfigurados(formValues.id_tipo_documento);
      }
    } else {
      if (formValues.id_tipo_documento) {
        fetchCamposConfigurados(formValues.id_tipo_documento, undefined);
      }
    }
  };

  const handleArquivoChange = (e) => {
    const arquivo = e.target.files[0];
    const sizeFile = tamanhoMaximoArquivoMB * 1024 ** 2; // Tamanho máximo em bytes
    if (!arquivo) {
      console.warn("⚠️ Nenhum arquivo selecionado");
      return;
    }
    
    console.log("📄 Arquivo selecionado:", {
      nome: arquivo.name,
      tamanho: arquivo.size,
      tamanhoMB: (arquivo.size / (1024 * 1024)).toFixed(2),
      tipo: arquivo.type,
      ultimaModificacao: new Date(arquivo.lastModified).toLocaleString(),
      tamanhoMaximoPermitidoMB: tamanhoMaximoArquivoMB
    });

    // Validação de tamanho
    if (arquivo.size > sizeFile) {
      const tamanhoMB = (arquivo.size / (1024 * 1024)).toFixed(2);
      setErroArquivo(`Arquivo maior que ${tamanhoMaximoArquivoMB} MB. Tamanho atual: ${tamanhoMB} MB`);
      setSelectedFile(null);
      setBase64File("");
      return;
    }

    // Validação de tipo - aceita PDF mesmo se o tipo MIME não estiver correto
    const isPDF = arquivo.type === "application/pdf" || 
                  arquivo.name.toLowerCase().endsWith('.pdf') ||
                  arquivo.type === "";
    
    if (!isPDF) {
      setErroArquivo("Somente arquivos PDF são permitidos.");
      setSelectedFile(null);
      setBase64File("");
      return;
    }
    
    setErroArquivo(null);
    setSelectedFile(arquivo);

    const reader = new FileReader();
    reader.onloadend = () => {
      try {
        const result = reader.result;
        if (!result || !result.includes(',')) {
          throw new Error("Formato de resultado do FileReader inválido");
        }
        const base64 = result.split(",")[1];
        if (!base64 || base64.length === 0) {
          throw new Error("Base64 vazio após conversão");
        }
        setBase64File(base64);
      } catch (error) {
        console.error("Erro ao converter arquivo para base64:", error);
        setErroArquivo("Erro ao processar o arquivo. Tente novamente.");
        setSelectedFile(null);
        setBase64File("");
      }
    };
    reader.onerror = (error) => {
      console.error("Erro ao ler arquivo:", error);
      setErroArquivo("Erro ao ler o arquivo. Verifique se o arquivo não está corrompido.");
      setSelectedFile(null);
      setBase64File("");
    };
    reader.readAsDataURL(arquivo);
  };

  const handleExcluirArquivo = async () => {
    if (documento?.id) {
      try {
        await editarAnexo(documento.id, null, true);
        setAnexoAtual(null);
        setBase64File("");
      } catch (error) {
        console.error("Erro ao remover anexo:", error);
        setErroGeral("Falha ao remover o anexo.");
      }
    } else {
      setAnexoAtual(null);
      setBase64File("");
    }
  };

  const handleUploadArquivo = async () => {
    if (!selectedFile || !base64File) {
      setErroArquivo("Selecione um arquivo PDF antes de enviar.");
      return;
    }

    if (!documento?.id) {
      setShowArquivoModal(false);
      setErroArquivo(null);
      return;
    }

    try {
      const { data } = await inserirAnexo(documento.id, base64File, selectedFile.name);
      setAnexoAtual({
        nome: data.nome_anexo || selectedFile.name,
        path: data.path || data.arquivo_documento || "",
      });
      setShowArquivoModal(false);
      setSelectedFile(null);
      setBase64File("");
      setErroArquivo(null);
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || "Falha ao enviar o anexo.";
      setErroArquivo(errorMessage);
      setErroGeral(errorMessage);
    }
  };

  const handleOpenUsuariosModal = async () => {
    setShowUsuariosModal(true);
    setPageAtualUsuarios(1);
    await fetchUsuariosNotificacao();
    if (documento && documento.id) {
      try {
        const { data } = await api.get(
          `${BASE_URL}/api/documentos/ListarUsuariosNotificacaoConfigurados/${documento.id}`
        );
        const configurados = data.data.map((u) => u.id_usuario);
        setUsuariosNotificacao(configurados);
      } catch (error) {
        console.error("Erro ao buscar usuários configurados:", error);
      }
    }
  };

  const fetchAditivosDocumento = useCallback(async (idDoc) => {
    if (!idDoc) return [];
    setAditivosLoading(true);
    setErroAditivo(null);
    try {
      const token = localStorage.getItem("authToken");
      const { data } = await api.get(
        `${BASE_URL}/api/documentos/ListarAditivosDocumento/${idDoc}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      const lista = Array.isArray(data?.data) ? data.data : [];
      setListaAditivos(lista);
      return lista;
    } catch (err) {
      console.error("Erro ao listar aditivos:", err);
      setErroAditivo(err?.response?.data?.message || err?.message || "Erro ao carregar aditivos.");
      setListaAditivos([]);
      return [];
    } finally {
      setAditivosLoading(false);
    }
  }, []);

  const handleOpenAditivosModal = async () => {
    if (!documento?.id) return;
    setShowAditivosModal(true);
    setErroAditivo(null);
    const lista = await fetchAditivosDocumento(documento.id);
    const ordenados = [...lista].sort((a, b) => (a.numero_aditivo || 0) - (b.numero_aditivo || 0));
    const ultimo = ordenados.length > 0 ? ordenados[ordenados.length - 1] : null;
    const dtInicialSugerida = ultimo?.dt_vencimento ? dataMaisUmDia(ultimo.dt_vencimento) : "";
    const dtInicialMySQL = dtInicialSugerida ? parseDDMMYYYYToMySQL(dtInicialSugerida) : "";
    const diasUltimaRenovacao =
      ultimo?.dt_inicial && ultimo?.dt_vencimento
        ? diferencaEmDias(ultimo.dt_inicial, ultimo.dt_vencimento)
        : null;
    const dtVencimentoSugerida =
      dtInicialMySQL && diasUltimaRenovacao != null && diasUltimaRenovacao >= 0
        ? adicionarDias(dtInicialMySQL, diasUltimaRenovacao)
        : "";
    setFormAditivo({
      dt_inicial: dtInicialMySQL,
      dt_vencimento: dtVencimentoSugerida,
      nr_dias_aviso: "",
      observacao: "",
      status: "Vigente",
    });
    setSelectedFileNovoAditivo(null);
  };

  // Carrega aditivos ao abrir o modal para edição (documento já salvo)
  useEffect(() => {
    if (show && documentoId) {
      setPageAtualAditivos(1);
      fetchAditivosDocumento(documentoId);
    }
  }, [show, documentoId, fetchAditivosDocumento]);

  // Sincroniza anexo exibido com o aditivo mais recente que possui arquivo
  useEffect(() => {
    const aditivosComArquivo = [...listaAditivos].filter((a) => a.nome_anexo || a.arquivo_documento);
    if (!aditivosComArquivo.length) return;
    const maisRecente = aditivosComArquivo.sort(
      (a, b) => (b.numero_aditivo || 0) - (a.numero_aditivo || 0)
    )[0];
    setAnexoAtual({
      nome: maisRecente.nome_anexo || "Anexo",
      path: maisRecente.arquivo_documento || "",
    });
  }, [listaAditivos]);

  // Ao abrir o modal: mostrar no console as rotas executadas
  const docId = documento?.id;
  const docIdTipo = documento?.id_tipo_documento;
  const docIdEmpresa = documento?.id_empresa;
  useEffect(() => {
    if (!show) return;
    const rotas = [];
    if (docId) {
      rotas.push({ metodo: "GET", rota: `${BASE_URL}/api/documentos/ObterDocumentoCompleto/${docId}` });
      rotas.push({ metodo: "GET", rota: `${BASE_URL}/api/documentos/ListarAditivosDocumento/${docId}` });
      if (docIdTipo) {
        const idEntidadeRota = docIdEmpresa || entidadeID;
        rotas.push({ metodo: "GET", rota: `${BASE_URL}/api/configuracaoCampos/ListarConfiguracoesCamposPorTipo/${docIdTipo}` });
        rotas.push({ metodo: "GET", rota: `${BASE_URL}/api/configuracaoCampos/ListarConfiguracoesCamposPorTipoDocumentos/${docIdTipo}` });
        if (idEntidadeRota) rotas.push({ metodo: "GET", rota: `${BASE_URL}/api/camposCustomizados/ListarCamposPorTipoDocumento/${idEntidadeRota}/${docIdTipo}` });
      }
    } else {
      rotas.push({ info: "Adicionar documento — rotas ao selecionar tipo/empresa:" });
      rotas.push({ metodo: "GET", rota: `${BASE_URL}/api/configuracaoCampos/ListarConfiguracoesCamposPorTipo/:idTipo` });
      rotas.push({ metodo: "GET", rota: `${BASE_URL}/api/configuracaoCampos/ListarConfiguracoesCamposPorTipoDocumentos/:id_tipo_documento` });
      rotas.push({ metodo: "GET", rota: `${BASE_URL}/api/camposCustomizados/ListarCamposPorTipoDocumento/:idEntidade/:idTipoDocumento` });
    }
  }, [show, docId, docIdTipo, docIdEmpresa, entidadeID]);

  // Sempre que os aditivos carregarem/mudarem, exibe nos campos Data Inicial e Data Vencimento
  // do modal principal os valores do aditivo INICIAL (numero_aditivo = 0) — esses campos
  // representam a origem do documento, não o período vigente após renovações.
  useEffect(() => {
    if (!show || !documentoId) return;
    if (listaAditivos.length === 0) return;
    const inicial = listaAditivos.find((a) => (a.numero_aditivo || 0) === 0);
    if (!inicial) return;
    setFormValues((prev) => ({
      ...prev,
      dt_inicial:    inicial.dt_inicial    ? normalizarDataParaInput(inicial.dt_inicial)    : prev.dt_inicial,
      dt_vencimento: inicial.dt_vencimento ? normalizarDataParaInput(inicial.dt_vencimento) : prev.dt_vencimento,
    }));
  }, [show, documentoId, listaAditivos]);

  const listaAditivosOrdenados = [...listaAditivos].sort((a, b) => (b.numero_aditivo || 0) - (a.numero_aditivo || 0));
  const totalPagesAditivos = Math.ceil(listaAditivosOrdenados.length / ADITIVOS_ITEMS_PER_PAGE) || 1;
  const inicioAditivos = (pageAtualAditivos - 1) * ADITIVOS_ITEMS_PER_PAGE;
  const aditivosPagina = listaAditivosOrdenados.slice(inicioAditivos, inicioAditivos + ADITIVOS_ITEMS_PER_PAGE);
  const totalRecordsAditivos = listaAditivosOrdenados.length;
  const startRecordAditivos = totalRecordsAditivos === 0 ? 0 : inicioAditivos + 1;
  const endRecordAditivos = Math.min(pageAtualAditivos * ADITIVOS_ITEMS_PER_PAGE, totalRecordsAditivos);

  const handleChangePageAditivos = (page) => {
    setPageAtualAditivos(page);
  };

  const handleExcluirAditivo = async (idAditivo) => {
    if (!documento?.id || !idAditivo) return;
    if (!window.confirm("Excluir este aditivo? Esta ação não pode ser desfeita.")) return;
    setErroAditivo(null);
    try {
      const token = localStorage.getItem("authToken");
      await api.delete(
        `${BASE_URL}/api/documentos/ExcluirAditivo/${idAditivo}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      const listaAtualizada = await fetchAditivosDocumento(documento.id);
      const inicialAtual = listaAtualizada.find((a) => (a.numero_aditivo || 0) === 0);
      if (inicialAtual) {
        setFormValues((prev) => ({
          ...prev,
          dt_inicial: inicialAtual.dt_inicial ? normalizarDataParaInput(inicialAtual.dt_inicial) : prev.dt_inicial,
          dt_vencimento: inicialAtual.dt_vencimento ? normalizarDataParaInput(inicialAtual.dt_vencimento) : prev.dt_vencimento,
        }));
      } else {
        setFormValues((prev) => ({
          ...prev,
          dt_inicial: documento?.dt_inicial ? normalizarDataParaInput(documento.dt_inicial) : prev.dt_inicial,
          dt_vencimento: documento?.dt_vencimento ? normalizarDataParaInput(documento.dt_vencimento) : prev.dt_vencimento,
        }));
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Erro ao excluir aditivo.";
      setErroAditivo(msg);
    }
  };

  const handleOpenEditarAditivo = (aditivo) => {
    const dtInicial = normalizarDataParaInput(aditivo.dt_inicial ?? aditivo.data_inicial);
    const dtVencimento = normalizarDataParaInput(aditivo.dt_vencimento ?? aditivo.data_vencimento);
    setFormAditivo({
      dt_inicial: dtInicial,
      dt_vencimento: dtVencimento,
      nr_dias_aviso: "",
      observacao: aditivo.observacao != null ? String(aditivo.observacao) : "",
      status: aditivo.status || "Vigente",
    });
    setAditivoEditando(aditivo);
    setSelectedFileNovoAditivo(null);
    setErroAditivo(null);
    setShowAditivosModal(true);
  };

  const handleSaveEditarAditivo = async () => {
    if (!aditivoEditando?.id) return;
    const dtInicial = formAditivo.dt_inicial?.trim();
    const dtVencimento = formAditivo.dt_vencimento?.trim();
    if (!dtInicial && !dtVencimento) {
      setErroAditivo("Informe ao menos uma das datas (inicial ou vencimento).");
      return;
    }
    if (dtInicial && dtVencimento && dtVencimento < dtInicial) {
      setErroAditivo("A data de vencimento não pode ser anterior à data inicial.");
      return;
    }
    setAditivoSalvando(true);
    setErroAditivo(null);
    try {
      const token = localStorage.getItem("authToken");
      const body = {};
      if (dtInicial) body.dt_inicial = formatarData(dtInicial);
      if (dtVencimento) body.dt_vencimento = formatarData(dtVencimento);
      body.observacao = formAditivo.observacao?.trim() || null;
      await api.put(
        `${BASE_URL}/api/documentos/EditarAditivo/${aditivoEditando.id}`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      setShowAditivosModal(false);
      setFormAditivo({ dt_inicial: "", dt_vencimento: "", nr_dias_aviso: "", observacao: "", status: "Vigente" });
      setAditivoEditando(null);
      const listaAtualizada = await fetchAditivosDocumento(documento.id);
      const inicialAtual = listaAtualizada.find((a) => (a.numero_aditivo || 0) === 0);
      if (inicialAtual && inicialAtual.id === aditivoEditando.id) {
        setFormValues((prev) => ({
          ...prev,
          dt_inicial: inicialAtual.dt_inicial ? normalizarDataParaInput(inicialAtual.dt_inicial) : prev.dt_inicial,
          dt_vencimento: inicialAtual.dt_vencimento ? normalizarDataParaInput(inicialAtual.dt_vencimento) : prev.dt_vencimento,
        }));
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Erro ao atualizar aditivo.";
      setErroAditivo(msg);
    } finally {
      setAditivoSalvando(false);
    }
  };

  const handleAnexoNovoAditivoChange = (e) => {
    const arquivo = e.target.files?.[0];
    if (!arquivo) return;
    if (arquivo.type !== "application/pdf") {
      setErroAditivo("Apenas arquivos PDF são permitidos.");
      return;
    }
    const maxBytes = (tamanhoMaximoArquivoMB || 4) * 1024 * 1024;
    if (arquivo.size > maxBytes) {
      setErroAditivo(`O arquivo deve ter no máximo ${tamanhoMaximoArquivoMB} MB.`);
      return;
    }
    setErroAditivo(null);
    setSelectedFileNovoAditivo(arquivo);
    e.target.value = "";
  };

  const handleOpenAnexoAditivoModal = (aditivo) => {
    setAditivoAnexoSelecionado(aditivo);
    setSelectedFileAditivo(null);
    setErroArquivoAditivo(null);
    setShowAnexoAditivoModal(true);
  };

  const handleCloseAnexoAditivoModal = () => {
    setShowAnexoAditivoModal(false);
    setAditivoAnexoSelecionado(null);
    setSelectedFileAditivo(null);
    setErroArquivoAditivo(null);
  };

  const handleClickAnexoAditivo = (aditivo) => {
    if (aditivo?.tem_anexo || aditivo?.arquivo_documento) {
      abrirVisualizadorPdfAditivo(aditivo);
      return;
    }
    handleOpenAnexoAditivoModal(aditivo);
  };

  const handleArquivoChangeAditivo = (e) => {
    const arquivo = e.target.files?.[0];
    if (!arquivo) return;
    if (arquivo.type !== "application/pdf") {
      setErroArquivoAditivo("Apenas arquivos PDF são permitidos.");
      return;
    }
    const maxBytes = (tamanhoMaximoArquivoMB || 4) * 1024 * 1024;
    if (arquivo.size > maxBytes) {
      setErroArquivoAditivo(`O arquivo deve ter no máximo ${tamanhoMaximoArquivoMB} MB.`);
      return;
    }
    setErroArquivoAditivo(null);
    setSelectedFileAditivo(arquivo);
  };

  const handleExcluirArquivoAditivo = async () => {
    if (!aditivoAnexoSelecionado?.id) return;
    setAnexoAditivoUploading(true);
    setErroArquivoAditivo(null);
    try {
      const token = localStorage.getItem("authToken");
      await api.put(
        `${BASE_URL}/api/documentos/EditarAditivo/${aditivoAnexoSelecionado.id}`,
        { arquivo_documento: null, nome_anexo: null },
        {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      await fetchAditivosDocumento(documento.id);
      handleCloseAnexoAditivoModal();
    } catch (err) {
      setErroArquivoAditivo(err?.response?.data?.message || err?.message || "Falha ao remover o anexo.");
    } finally {
      setAnexoAditivoUploading(false);
    }
  };

  const handleUploadArquivoAditivo = async () => {
    if (!aditivoAnexoSelecionado?.id || !selectedFileAditivo) {
      setErroArquivoAditivo("Selecione um arquivo PDF antes de enviar.");
      return;
    }
    setAnexoAditivoUploading(true);
    setErroArquivoAditivo(null);
    try {
      await inserirAnexoAditivo(aditivoAnexoSelecionado.id, selectedFileAditivo);
      await fetchAditivosDocumento(documento.id);
      handleCloseAnexoAditivoModal();
    } catch (err) {
      setErroArquivoAditivo(err?.response?.data?.message || err?.message || "Falha ao enviar o anexo.");
    } finally {
      setAnexoAditivoUploading(false);
    }
  };

  const handleSaveAditivo = async () => {
    if (!documento?.id) return;
    setErroAditivo(null);
    if (!aditivoEditando) {
      if (!formAditivo.dt_inicial?.trim()) {
        setErroAditivo("A data inicial é obrigatória.");
        return;
      }
      if (!formAditivo.dt_vencimento?.trim()) {
        setErroAditivo("A data de vencimento é obrigatória.");
        return;
      }
    }
    const ordenados = [...listaAditivos].sort((a, b) => (b.numero_aditivo || 0) - (a.numero_aditivo || 0));
    const ultimoAditivo = ordenados[0];
    const minDataInicial = ultimoAditivo?.dt_vencimento
      ? parseDDMMYYYYToMySQL(dataMaisUmDia(ultimoAditivo.dt_vencimento))
      : null;
    if (minDataInicial && formAditivo.dt_inicial?.trim()) {
      const dtInicial = formAditivo.dt_inicial.trim();
      if (dtInicial < minDataInicial) {
        setErroAditivo("A data inicial do novo aditivo não pode ser anterior ao dia seguinte à data final do aditivo anterior.");
        return;
      }
    }
    if (formAditivo.dt_inicial?.trim() && formAditivo.dt_vencimento?.trim()) {
      const dtInicial = formAditivo.dt_inicial.trim();
      const dtVencimento = formAditivo.dt_vencimento.trim();
      if (dtVencimento < dtInicial) {
        setErroAditivo("A data de vencimento não pode ser anterior à data inicial.");
        return;
      }
    }
    setAditivoSalvando(true);
    try {
      const token = localStorage.getItem("authToken");
      const payload = {
        id_documento: documento.id,
        dt_inicial: formAditivo.dt_inicial?.trim() ? formatarData(formAditivo.dt_inicial.trim()) : null,
        dt_vencimento: formAditivo.dt_vencimento?.trim() ? formatarData(formAditivo.dt_vencimento.trim()) : null,
        nr_dias_aviso: null,
        observacao: formAditivo.observacao?.trim() || null,
        status: formAditivo.status || "Vigente",
        id_usuario: idUsuarioLogado ? Number(idUsuarioLogado) : null,
      };
      const { data: resData } = await api.post(
        `${BASE_URL}/api/documentos/InserirAditivo`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      const newAditivoId = resData?.id ?? resData?.aditivo?.id;
      if (newAditivoId && selectedFileNovoAditivo) {
        try {
          await inserirAnexoAditivo(newAditivoId, selectedFileNovoAditivo);
        } catch (errAnexo) {
          setErroAditivo(errAnexo?.response?.data?.message || errAnexo?.message || "Aditivo criado, mas falha ao enviar anexo.");
          setAditivoSalvando(false);
          return;
        }
      }
      setFormAditivo({ dt_inicial: "", dt_vencimento: "", nr_dias_aviso: "", observacao: "", status: "Vigente" });
      setSelectedFileNovoAditivo(null);
      setShowAditivosModal(false);
      setErroAditivo(null);
      const listaAtualizada = await fetchAditivosDocumento(documento.id);
      const inicialAtual = listaAtualizada.find((a) => (a.numero_aditivo || 0) === 0);
      if (inicialAtual) {
        setFormValues((prev) => ({
          ...prev,
          dt_inicial: inicialAtual.dt_inicial ? normalizarDataParaInput(inicialAtual.dt_inicial) : prev.dt_inicial,
          dt_vencimento: inicialAtual.dt_vencimento ? normalizarDataParaInput(inicialAtual.dt_vencimento) : prev.dt_vencimento,
        }));
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Erro ao registrar aditivo.";
      setErroAditivo(msg);
    } finally {
      setAditivoSalvando(false);
    }
  };

  const handleSearchChange = (term) => {
    setSearchTerm(term);
    setPageAtualUsuarios(1);
    if (term) {
      const filtered = listaUsuarios.filter((usuario) =>
        usuario.nome.toLowerCase().includes(term.toLowerCase())
      );
      setListaUsuariosFiltrada(filtered);
    } else {
      setListaUsuariosFiltrada(listaUsuarios);
    }
  };

  const handleUserClick = (userId) => {
    setUsuariosNotificacao((prevSelected) => {
      if (prevSelected.includes(userId)) {
        return prevSelected.filter((id) => id !== userId);
      }
      return [...prevSelected, userId];
    });
    setSearchTerm("");
    setListaUsuariosFiltrada(listaUsuarios);
  };

  const handleSaveUsuarios = async () => {
    try {
      await api.put(
        `${BASE_URL}/api/documentos/EditarUsuariosNotificacao/${documento.id}`,
        { usuarios: usuariosNotificacao }
      );
      setFormValues((prevValues) => ({
        ...prevValues,
        id_usuarios_notificacao: usuariosNotificacao.join(","),
      }));
      setShowUsuariosModal(false);
    } catch (error) {
      console.error("Erro ao salvar usuários de notificação:", error);
    }
  };

  // Carrega detalhes de agendamentos (todos: pendentes e executados)
  const fetchAgendamentosPorIDDetalhes = async (documentoId) => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/agendamentos/ListarAgendamentosDocumentoPorID/${documentoId}`
      );

      const agrupado = data.data.reduce((acc, item) => {
        const key = `${item.nome}||${item.periodicidade}||${item.data_proxima_execucao || ""}||${item.situacao || ""}`;
        if (!acc[key]) {
          acc[key] = {
            nome: item.nome,
            periodicidade: item.periodicidade,
            data_proxima_execucao: item.data_proxima_execucao || null,
            situacao: item.situacao,
            emails: [],
          };
        }
        if (item.usuario?.email && !acc[key].emails.includes(item.usuario.email)) {
          acc[key].emails.push(item.usuario.email);
        }
        return acc;
      }, {});

      setAgendamentoDetalhes(Object.values(agrupado));
    } catch (error) {
      console.error("Erro ao buscar detalhes de agendamentos por ID:", error);
      setAgendamentoDetalhes([]);
    }
  };

  const handleOpenAgendamentosModal = async () => {
    setAgendamentoDetalhes([]);
    setPendentesOnly(true);
    setAgendamentosPage(1);
    setShowAgendamentosModal(true);
    if (documento && documento.id) {
      setLoadingAgendamentos(true);
      await fetchAgendamentosPorIDDetalhes(documento.id);
      setLoadingAgendamentos(false);
    }
  };

  // Tipos de agendamento (lista disponível e configurados)
  const fetchTiposAgendamentoDisponiveis = async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/tiposAgendamentos/ListarTiposAgendamento/${entidadeID}`
      );
      setTiposAgendamentoDisponiveis(data.data);
    } catch (error) {
      console.error("Erro ao buscar tipos de agendamento disponíveis:", error);
    }
  };

  const fetchTipoDocumentoTiposAgendamentoConfigurados = async (tipoDocumentoId) => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/tiposDocumento/ListarTipoDocumentoTiposAgendamento/${tipoDocumentoId}`
      );
      const tiposIds = data.data.map((item) => item.id_tipo_agendamento);
      setTiposAgendamentoSelecionados(tiposIds);
      setTiposAgendamentoOriginais(tiposIds);
    } catch (error) {
      console.error(
        "Erro ao buscar tipos de agendamento configurados no tipo de documento:",
        error
      );
    }
  };

  const handleOpenTipoDocumentoTiposAgendamentoModal = async () => {
    if (!permiteConfigurarTipoDocumento) return;
    const tipoDocumento = obterTipoDocumentoSelecionado();
    if (!tipoDocumento?.id) return;
    setSelectedTipoParaAgendamento(tipoDocumento);
    setShowDocumentosTiposAgendamentoModal(true);
    setPageAtualTiposAgendamento(1);
    setSearchTermTiposAgendamento("");
    setTiposAgendamentoSelecionados([]);
    setTiposAgendamentoOriginais([]);
    await fetchTiposAgendamentoDisponiveis();
    await fetchTipoDocumentoTiposAgendamentoConfigurados(tipoDocumento.id);
  };

  const handleTipoAgendamentoClick = (tipoAgendamentoId) => {
    setTiposAgendamentoSelecionados((prevSelected) => {
      if (prevSelected.includes(tipoAgendamentoId)) {
        return prevSelected.filter((id) => id !== tipoAgendamentoId);
      }
      return [...prevSelected, tipoAgendamentoId];
    });
  };

  const handleSaveTipoDocumentoTiposAgendamento = async () => {
    if (!selectedTipoParaAgendamento?.id) return;
    try {
      await api.put(
        `${BASE_URL}/api/tiposDocumento/EditarTipoDocumentoTiposAgendamento/${selectedTipoParaAgendamento.id}`,
        { tipos_agendamento: tiposAgendamentoSelecionados }
      );

      const adicionados = tiposAgendamentoSelecionados.filter((id) => !tiposAgendamentoOriginais.includes(id));
      const removidos = tiposAgendamentoOriginais.filter((id) => !tiposAgendamentoSelecionados.includes(id));

      setShowDocumentosTiposAgendamentoModal(false);

      if (adicionados.length > 0) {
        await api.put(
          `${BASE_URL}/api/tiposDocumento/VincularAgendamentosAosDocumentos/${selectedTipoParaAgendamento.id}`,
          { tipos_agendamento: adicionados }
        );
      }

      if (removidos.length > 0) {
        await api.delete(
          `${BASE_URL}/api/tiposDocumento/DesvincularAgendamentosDoDocumentos/${selectedTipoParaAgendamento.id}`,
          { data: { tipos_agendamento: removidos } }
        );
      }
    } catch (error) {
      console.error("Erro ao salvar tipos de agendamento do tipo de documento:", error);
    }
  };

  // --------- effects ---------

  // 🔹 Carregar definição de campos do backend
  useEffect(() => {
    if (!show) return;
    const fetchDefinicaoCampos = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const { data } = await api.get(`${BASE_URL}/api/documentos/camposDocumento`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        setDefinicaoCampos(data.data);

        const initialValues = {};
        data.data.forEach((campo) => {
          if (!CAMPOS_REMOVIDOS_DOCUMENTOS.includes(campo.nome)) {
            initialValues[campo.nome] = campo.default;
          }
        });
        setFormValues(initialValues);
      } catch (error) {
        console.error("Erro ao buscar definição de campos:", error);
      }
    };

    fetchDefinicaoCampos();
  }, [show]);


  // Usuários (quando modal abre)
useEffect(() => {
  if (!show) return;

  const fetchUsuarios = async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/usuarios/ListarUsuariosNotificacao/${entidadeID}`
      );
      setListaUsuarios(data.data);
      setListaUsuariosFiltrada(data.data);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
    }
  };

  const fetchUsuariosConfigurados = async () => {
    if (documentoId) {
      try {
        const { data } = await api.get(
          `${BASE_URL}/api/documentos/ListarUsuariosNotificacaoConfigurados/${documentoId}`
        );
        setUsuariosNotificacao(data.data.map((u) => u.id_usuario));
      } catch (error) {
        console.error("Erro ao buscar usuários configurados:", error);
      }
    }
  };

  fetchUsuarios();
  fetchUsuariosConfigurados();
}, [show, documentoId, entidadeID]);

  useEffect(() => {
    if (show && !documento) {
      // definicaoCampos não é limpo — contém apenas os nomes das colunas da tabela e é necessário para montar o payload ao salvar
      setFormValues({ situacao: "V" });
      setConfiguracoesCampos([]);
      setSearchTipoDocumento("");
      setDropdownTipoDocumentoOpen(false);
      setSelectedFile(null);
      setAnexoAtual(null);
      setOpcoesCamposCustomizados({});
      setTipoCampoCustomizado({});
      setLoadingCampos(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, documento]);

  // Carregamentos gerais quando modal abre (inclui resetForm como dependência)
  const docIdForEffect = documento?.id;
  useEffect(() => {
  // --- fetch helpers definidos dentro do effect (como você já tinha) ---
  const fetchFiliais = async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/empresas/ListarEmpresas/${entidadeID}`
      );
      setFiliais(data.data);
    } catch (error) {
      console.error("Erro ao buscar filiais:", error);
    }
  };

  const fetchTiposPagamento = async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/tiposPagamento/ListarTiposPagamento/${entidadeID}`
      );
      setTiposPagamento(data.data);
    } catch (error) {
      console.error("Erro ao buscar tipos de pagamento:", error);
    }
  };

  const fetchIndiceCorrecao = async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/indicesCorrecao/ListarIndicesCorrecao/${entidadeID}`
      );
      setIndicesCorrecao(Array.isArray(data?.data) ? data.data : []);
    } catch (error) {
      console.error("Erro ao buscar índices de correção:", error);
    }
  };

  const fetchFornecedores = async () => {
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/empresas/ListarFornecedoresAtivos/${entidadeID}`
      );
      setFornecedores(data.data);
    } catch (error) {
      console.error("Erro ao buscar fornecedores:", error);
    }
  };

  // --- guarda de abertura do modal ---
  if (!show) {
    documentoIdCarregadoRef.current = null;
    return;
  }

  // dispara os carregamentos paralelamente (para dropdowns, etc.)
  Promise.all([
    recarregarTiposDocumento(),
    fetchTiposPagamento(),
    fetchIndiceCorrecao(),
    fetchFornecedores(),
    fetchFiliais(),
    fetchUsuarioResponsavel(),
    fetchUsuariosNotificacao(),
    fetchFuncionarios(null),
  ]).catch(() => { /* já logamos nos próprios fetches */ });

  // Cadastro novo (sem documento): não preencher form; o outro effect já limpou formValues/definicaoCampos
  if (!documento) {
    documentoIdCarregadoRef.current = null;
    return;
  }

  // Evita loop: só carrega documento completo uma vez por documento.id (parent pode repassar novo objeto a cada render)
  if (documentoIdCarregadoRef.current === documento.id) return;
  documentoIdCarregadoRef.current = documento.id;

  if (documento) {
    /*
    console.log("📄 [useEffect] Documento carregado:", {
      id: documento.id,
      id_empresa: documento.id_empresa,
      id_funcionario: documento.id_funcionario
    });
    */
    const base = definicaoCampos.length > 0
      ? definicaoCampos.reduce((acc, c) => {
          if (!CAMPOS_REMOVIDOS_DOCUMENTOS.includes(c.nome)) acc[c.nome] = c.default;
          return acc;
        }, {})
      : {};

    const docVals = { ...documento };
    if (docVals.dt_inicial) docVals.dt_inicial = normalizarDataParaInput(docVals.dt_inicial);
    if (docVals.dt_vencimento) docVals.dt_vencimento = normalizarDataParaInput(docVals.dt_vencimento);
    const { nome_anexo, arquivo_documento, ...restoDoc } = docVals;
    const anexoAtualPayload = nome_anexo || arquivo_documento ? { nome: nome_anexo || "", path: arquivo_documento || "" } : null;
    if (anexoAtualPayload) {
      setAnexoAtual(anexoAtualPayload);
    } else {
      setAnexoAtual(null);
    }
    const formPayloadInicial = { ...base, ...restoDoc };
    setFormValues(formPayloadInicial);

    // Carregar campos e documento completo de forma coordenada para evitar race condition.
    // fetchDocumentoCompleto é a fonte autoritativa: retorna definições + valores de todos os campos (inclusive customizados).
    // Não chamamos fetchCamposConfigurados em modo edição para evitar que ele sobrescreva configuracoesCampos depois.
    setLoadingCampos(true);
    fetchDocumentoCompleto(documento.id).then((completo) => {
      if (!completo) { setLoadingCampos(false); return; }

      //console.log("[DocumentosModal] Retorno do backend ao abrir documento (ObterDocumentoCompleto):", JSON.stringify(completo, null, 2));

      const byNome = {};
      const opcoesByCampo = {};
      const tiposByCampo = {};

      // Campos normais na raiz do documento (ObterDocumentoCompleto pode retornar id, nr_contrato, dt_vencimento, etc.)
      const ignorarKeys = ["campos_documento", "campos_customizados"];
      Object.keys(completo).forEach((key) => {
        if (ignorarKeys.includes(key) || Array.isArray(completo[key]) || (typeof completo[key] === "object" && completo[key] !== null)) return;
        const v = completo[key];
        if (key === "dt_inicial" || key === "dt_vencimento") {
          byNome[key] = v != null && v !== "" ? normalizarDataParaInput(v) : "";
        } else {
          byNome[key] = v != null && v !== "" ? v : "";
        }
      });

      // Resolve valor de um item (suporta formato com valor_texto, valor_numero, valor_data, id_opcao)
      const valorDe = (item, formatoData = false) => {
        const v =
          item.valor ??
          item.valor_texto ??
          (item.valor_numero != null ? item.valor_numero : null) ??
          (item.valor_data != null && item.valor_data !== "" ? item.valor_data : null) ??
          (item.id_opcao != null ? String(item.id_opcao) : null) ??
          "";
        if (formatoData && v) return normalizarDataParaInput(v);
        return v != null && v !== "" ? v : "";
      };

      // Novo formato: campos_documento (nome_campo, valor ou valor_texto/valor_numero/valor_data)
      const camposDoc = Array.isArray(completo.campos_documento) ? completo.campos_documento : [];
      const camposCustom = Array.isArray(completo.campos_customizados) ? completo.campos_customizados : [];

      if (camposDoc.length > 0 || camposCustom.length > 0) {
        camposDoc.forEach((c) => {
          const nome = c.nome_campo || c.nome;
          if (!nome) return;
          const v = valorDe(c);
          if (nome === "dt_inicial" || nome === "dt_vencimento") {
            byNome[nome] = v ? normalizarDataParaInput(v) : "";
          } else {
            byNome[nome] = v !== "" ? v : "";
          }
        });
        camposCustom.forEach((r) => {
          const nome = r.nome_campo || r.nome;
          if (!nome) return;
          const tipo = (r.tipo || r.tipo_campo || "").toLowerCase();
          tiposByCampo[nome] = tipo;
          if (tipo === "data") {
            byNome[nome] = valorDe(r, true);
          } else {
            byNome[nome] = valorDe(r);
          }
          if ((tipo === "select" || tipo === "cadastro") && Array.isArray(r.opcoes) && r.opcoes.length > 0) {
            opcoesByCampo[nome] = r.opcoes.slice().sort((a, b) => (Number(a.ordem) || 0) - (Number(b.ordem) || 0));
          }
        });

        const merged = [...camposDoc, ...camposCustom].sort((a, b) => (Number(a.ordem) || 0) - (Number(b.ordem) || 0));
        setConfiguracoesCampos(merged);
        setDefinicaoCampos(camposDoc.map((c) => ({ nome: c.nome_campo || c.nome, default: c.valor })));
        setFormValues((prev) => ({ ...prev, ...byNome }));
        if (Object.keys(opcoesByCampo).length > 0) {
          setOpcoesCamposCustomizados((prev) => ({ ...prev, ...opcoesByCampo }));
        }
        setTipoCampoCustomizado((prev) => ({ ...prev, ...tiposByCampo }));
      }

      // Alguns consumidores (ex.: Estatisticas) abrem o modal apenas com { id }.
      // Nesse fluxo, o fornecedor só fica disponível após ObterDocumentoCompleto
      // e pode vir na raiz ou dentro de campos_documento.
      const idFornecedorCompleto =
        completo.id_fornecedor ??
        byNome.id_fornecedor ??
        documento.id_fornecedor ??
        null;
      fetchFuncionarios(idFornecedorCompleto);

      // Atualizar anexo para exibir no "Gerenciar Anexo" (arquivo_documento e nome_anexo vêm na raiz ou em campos_documento)
      if (completo.arquivo_documento) {
        const path = String(completo.arquivo_documento).trim();
        const nomeDoBackend =
          completo.nome_anexo != null && completo.nome_anexo !== ""
            ? String(completo.nome_anexo)
            : (() => {
                const item = (completo.campos_documento || []).find(
                  (c) => (c.nome_campo || c.nome) === "nome_anexo"
                );
                const v = item?.valor ?? item?.valor_texto;
                return v != null && v !== "" ? String(v) : null;
              })();
        const nomeExibicao = nomeDoBackend || (path ? path.replace(/^.*[/\\]/, "") : null) || "Anexo";
        setAnexoAtual({ nome: nomeExibicao, path });
      }

      setLoadingCampos(false);
    }).catch(() => { setLoadingCampos(false); });

  } else {
    // novo registro: usa resetForm (que agora é dinâmico via definicaoCampos)
    resetForm();
  }
  // Usar docIdForEffect (primitivo) em vez de documento: evita reexecução quando o parent re-renderiza
  // e repassa um novo objeto documento (mesmo id). documentoIdCarregadoRef evita rodar o bloco de
  // carregamento mais de uma vez por documento.id por abertura. definicaoCampos/documento omitidos de propósito.
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [
  show,
  docIdForEffect,
  entidadeID,
  fetchUsuarioResponsavel,
  fetchUsuariosNotificacao,
  fetchFuncionarios,
  recarregarTiposDocumento,
  resetForm,
  fetchDocumentoCompleto,
]);


  // Buscar configuração de tamanho máximo de arquivo dinamicamente
  useEffect(() => {
    if (!show) return;
    const fetchConfiguracaoTamanhoArquivo = async () => {
      // Busca a configuração usando o ID da entidade (empresa principal)
      if (entidadeID) {
        try {
          const response = await api.get(
            `${BASE_URL}/api/empresasConfiguracoes/listarConfiguracoes/${entidadeID}`,
            {
              params: { incluir_logotipo: "N" },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                "id_entidade": entidadeID,
              },
            }
          );
          
          if (response.data && response.data.tamanho_maximo_arquivo_mb) {
            const tamanhoMax = response.data.tamanho_maximo_arquivo_mb;
            setTamanhoMaximoArquivoMB(tamanhoMax);
            //console.log(`✅ Tamanho máximo de arquivo configurado: ${tamanhoMax} MB para entidade ${entidadeID}`);
          } else {
            // Usa valor padrão se não encontrar configuração
            setTamanhoMaximoArquivoMB(4);
          }
        } catch (error) {
          console.error("Erro ao buscar configuração de tamanho máximo:", error);
          // Em caso de erro, usa valor padrão
          setTamanhoMaximoArquivoMB(4);
        }
      } else {
        // Se não houver entidade ID, usa valor padrão
        setTamanhoMaximoArquivoMB(4);
      }
    };

    fetchConfiguracaoTamanhoArquivo();
  }, [show, entidadeID]);

  // --------- UI dinâmico por configuração ---------
  const renderCamposVisiveis = () => {
    return configuracoesCampos
      .filter(
        (campoConfig) =>
          campoConfig.visivel !== "N" &&
          campoConfig.nome_campo !== "id_tipo_documento" &&
          campoConfig.nome_campo !== "id_empresa" &&
          !(documento?.id && CAMPOS_ADITIVO_INICIAL.includes(campoConfig.nome_campo)) &&
          !CAMPOS_REMOVIDOS_DOCUMENTOS.includes(campoConfig.nome_campo)
      )
      .sort((a, b) => a.ordem - b.ordem)
      .map((campoConfig) => {
        const nomeCampo = campoConfig.nome_campo;
        const labelCampo = campoConfig.descricao || nomeCampo;
        const isCampoDataAditivoInicial = CAMPOS_ADITIVO_INICIAL.includes(nomeCampo);

        return (
          <Col xs={isCampoDataAditivoInicial ? 6 : 12} md={isCampoDataAditivoInicial ? 3 : 6} key={nomeCampo}>
            <Form.Group controlId={nomeCampo}>
              <Form.Label>
                {labelCampo}
                {campoConfig.obrigatorio === "S" && <span className="text-danger"> *</span>}
              </Form.Label>

              {nomeCampo === "id_fornecedor" ? (
                // Envolve num <div title> em vez de só no <select disabled>: elementos
                // desabilitados nao disparam eventos de mouse de forma confiavel em
                // todos os navegadores, entao o title no proprio select as vezes nao
                // aparece ao passar o mouse.
                fornecedores.length === 0 ? (
                  <div className="dm-select-add-combo">
                    <Form.Select
                      className="dm-select-add-combo-select"
                      value=""
                      disabled
                    >
                      <option value="">Nenhum fornecedor cadastrado</option>
                    </Form.Select>
                    <span
                      className="dm-select-add-combo-button-wrapper"
                      title={!permiteCadastrarFornecedor ? MENSAGEM_SEM_PERMISSAO_RECURSO : undefined}
                    >
                      <button
                        type="button"
                        className="dm-select-add-combo-button"
                        onClick={abrirCadastroFornecedor}
                        aria-label="Cadastrar fornecedor"
                        title={permiteCadastrarFornecedor ? "Cadastrar fornecedor" : undefined}
                        disabled={!permiteCadastrarFornecedor}
                      >
                        <span className="dm-select-add-action-circle" aria-hidden="true">
                          +
                        </span>
                      </button>
                    </span>
                  </div>
                ) : (
                  <div className="dm-select-add-combo">
                    <Form.Select
                      className="dm-select-add-combo-select"
                      value={formValues.id_fornecedor || ""}
                      onChange={(e) => {
                        const fornecedorId = e.target.value;
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          id_fornecedor: fornecedorId,
                          id_funcionario: "",
                        }));
                        fetchFuncionarios(fornecedorId || null);
                      }}
                    >
                      <option value="">Selecione o Fornecedor</option>
                      {fornecedores.map((fornecedor) => (
                        <option key={fornecedor.id} value={fornecedor.id}>
                          {fornecedor.razao_social || fornecedor.fantasia || fornecedor.cnpj}
                        </option>
                      ))}
                    </Form.Select>
                    <span
                      className="dm-select-add-combo-button-wrapper"
                      title={!permiteCadastrarFornecedor ? MENSAGEM_SEM_PERMISSAO_RECURSO : undefined}
                    >
                      <button
                        type="button"
                        className="dm-select-add-combo-button"
                        onClick={abrirCadastroFornecedor}
                        aria-label="Adicionar fornecedor"
                        title={permiteCadastrarFornecedor ? "Adicionar fornecedor" : undefined}
                        disabled={!permiteCadastrarFornecedor}
                      >
                        <span className="dm-select-add-action-circle" aria-hidden="true">
                          +
                        </span>
                      </button>
                    </span>
                  </div>
                )
              ) : nomeCampo === "id_tipo_pagamento" ? (
                <div className="dm-select-add-combo">
                  <Form.Select
                    className="dm-select-add-combo-select"
                    value={formValues.id_tipo_pagamento || ""}
                    disabled={tiposPagamento.length === 0}
                    onChange={(e) =>
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        id_tipo_pagamento: e.target.value,
                      }))
                    }
                  >
                    <option value="">
                      {tiposPagamento.length === 0
                        ? "Nenhum tipo de pagamento cadastrado"
                        : "Selecione o Tipo de Pagamento"}
                    </option>
                    {tiposPagamento.map((pagamento) => (
                      <option key={pagamento.id} value={pagamento.id}>
                        {pagamento.descricao}
                      </option>
                    ))}
                  </Form.Select>
                  <span
                    className="dm-select-add-combo-button-wrapper"
                    title={!permiteCadastrarTipoPagamento ? MENSAGEM_SEM_PERMISSAO_RECURSO : undefined}
                  >
                    <button
                      type="button"
                      className="dm-select-add-combo-button"
                      onClick={abrirCadastroTipoPagamento}
                      aria-label={
                        tiposPagamento.length === 0
                          ? "Cadastrar tipo de pagamento"
                          : "Adicionar tipo de pagamento"
                      }
                      title={
                        permiteCadastrarTipoPagamento
                          ? tiposPagamento.length === 0
                            ? "Cadastrar tipo de pagamento"
                            : "Adicionar tipo de pagamento"
                          : undefined
                      }
                      disabled={!permiteCadastrarTipoPagamento}
                    >
                      <span className="dm-select-add-action-circle" aria-hidden="true">
                        +
                      </span>
                    </button>
                  </span>
                </div>
              ) : nomeCampo === "id_indice_correcao" ? (
                <div className="dm-select-add-combo">
                <Form.Select
                  className="dm-select-add-combo-select"
                  value={formValues.id_indice_correcao || ""}
                  disabled={indicesCorrecao.length === 0}
                  onChange={(e) =>
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      id_indice_correcao: e.target.value,
                    }))
                  }
                >
                  <option value="">
                    {indicesCorrecao.length === 0
                      ? "Nenhum indice de correcao cadastrado"
                      : "Selecione o Índice de Correção"}
                  </option>
                  {indicesCorrecao.map((indice) => (
                    <option key={indice.id} value={indice.id}>
                      {indice.nome}
                    </option>
                  ))}
                </Form.Select>
                    <span
                      className="dm-select-add-combo-button-wrapper"
                      title={!permiteCadastrarIndiceCorrecao ? MENSAGEM_SEM_PERMISSAO_RECURSO : undefined}
                    >
                      <button
                        type="button"
                        className="dm-select-add-combo-button"
                        onClick={abrirCadastroIndiceCorrecao}
                        aria-label={
                          indicesCorrecao.length === 0
                            ? "Cadastrar indice de correcao"
                            : "Adicionar indice de correcao"
                        }
                        title={
                          permiteCadastrarIndiceCorrecao
                            ? indicesCorrecao.length === 0
                              ? "Cadastrar indice de correcao"
                              : "Adicionar indice de correcao"
                            : undefined
                        }
                        disabled={!permiteCadastrarIndiceCorrecao}
                      >
                        <span className="dm-select-add-action-circle" aria-hidden="true">
                          +
                        </span>
                      </button>
                    </span>
                  </div>
              ) : nomeCampo === "id_usuario_respo" ? (
                <Form.Select
                  value={formValues.id_usuario_respo || ""}
                  onChange={(e) =>
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      id_usuario_respo: e.target.value,
                    }))
                  }
                >
                  <option value="">Selecione o Responsável</option>
                  {usuarioResponsavel.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.nome}
                    </option>
                  ))}
                </Form.Select>
              ) : nomeCampo === "id_funcionario" ? (
                !formValues.id_fornecedor ? (
                  <div className="dm-select-add-combo">
                    <Form.Select
                      className="dm-select-add-combo-select"
                      value=""
                      disabled
                    >
                      <option value="">Selecione o Fornecedor primeiro</option>
                    </Form.Select>
                    <span
                      className="dm-select-add-combo-button-wrapper"
                      title="Selecione o Fornecedor primeiro"
                    >
                      <button
                        type="button"
                        className="dm-select-add-combo-button"
                        aria-label="Adicionar funcionario"
                        title="Selecione o Fornecedor primeiro"
                        disabled
                      >
                        <span className="dm-select-add-action-circle" aria-hidden="true">
                          +
                        </span>
                      </button>
                    </span>
                  </div>
                ) : funcionarios.length === 0 ? (
                  <div className="dm-select-add-combo">
                    <Form.Select
                      className="dm-select-add-combo-select"
                      value=""
                      disabled
                    >
                      <option value="">Nenhum funcionario cadastrado</option>
                    </Form.Select>
                    <span
                      className="dm-select-add-combo-button-wrapper"
                      title={!permiteCadastrarFuncionario ? MENSAGEM_SEM_PERMISSAO_RECURSO : undefined}
                    >
                      <button
                        type="button"
                        className="dm-select-add-combo-button"
                        onClick={abrirCadastroFuncionario}
                        aria-label="Cadastrar funcionario"
                        title={permiteCadastrarFuncionario ? "Cadastrar funcionario" : undefined}
                        disabled={!permiteCadastrarFuncionario}
                      >
                        <span className="dm-select-add-action-circle" aria-hidden="true">
                          +
                        </span>
                      </button>
                    </span>
                  </div>
                ) : (
                  <div className="dm-select-add-combo">
                    <Form.Select
                      className="dm-select-add-combo-select"
                      value={formValues.id_funcionario || ""}
                      onChange={(e) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          id_funcionario: e.target.value,
                        }))
                      }
                    >
                      <option value="">Selecione o Funcionário</option>
                      {funcionarios.map((funcionario) => (
                        <option key={funcionario.id} value={funcionario.id}>
                          {funcionario.nome}{funcionario.cpf ? ` (${funcionario.cpf})` : ""}
                        </option>
                      ))}
                    </Form.Select>
                    <span
                      className="dm-select-add-combo-button-wrapper"
                      title={!permiteCadastrarFuncionario ? MENSAGEM_SEM_PERMISSAO_RECURSO : undefined}
                    >
                      <button
                        type="button"
                        className="dm-select-add-combo-button"
                        onClick={abrirCadastroFuncionario}
                        aria-label="Adicionar funcionario"
                        title={permiteCadastrarFuncionario ? "Adicionar funcionario" : undefined}
                        disabled={!permiteCadastrarFuncionario}
                      >
                        <span className="dm-select-add-action-circle" aria-hidden="true">
                          +
                        </span>
                      </button>
                    </span>
                  </div>
                )
              ) : nomeCampo === "dt_inicial" ? (
                <Data
                  value={formValues.dt_inicial || ""}
                  onChange={(iso) =>
                    setFormValues((prev) => ({ ...prev, dt_inicial: iso }))
                  }
                  disabled={!!documento?.id}
                  required={campoConfig.obrigatorio === "S"}
                  title={
                    documento?.id
                      ? "Data inicial do período de vigência original do documento (aditivo inicial). Para alterar, use Aditivo/Renovação de Documento."
                      : "Data em que o período de vigência do documento começa a valer — será registrada como o aditivo inicial (nº 0)."
                  }
                />
              ) : nomeCampo === "dt_vencimento" ? (
                <Data
                  value={formValues.dt_vencimento || ""}
                  onChange={(iso) =>
                    setFormValues((prev) => ({ ...prev, dt_vencimento: iso }))
                  }
                  disabled={!!documento?.id}
                  required={campoConfig.obrigatorio === "S"}
                  title={
                    documento?.id
                      ? "Data final do período de vigência original do documento (aditivo inicial). Para alterar, use Aditivo/Renovação de Documento."
                      : "Data em que o período de vigência do documento termina — será registrada como o aditivo inicial (nº 0)."
                  }
                />
              ) : nomeCampo === "situacao" ? (
                <Form.Select
                  value={formValues.situacao || "V"}
                  onChange={(e) =>
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      situacao: e.target.value,
                    }))
                  }
                >
                  <option value="V">Vigente</option>
                  <option value="A">Arquivado</option>
                </Form.Select>
              ) : (() => {
                const tipo = String(campoConfig.tipo_campo || campoConfig.tipo || tipoCampoCustomizado[nomeCampo] || "").toLowerCase();
                if (tipo === "numero" || tipo === "inteiro") {
                  const valorAtual = formValues[nomeCampo];
                  const exibir = valorAtual === undefined || valorAtual === null ? "" : String(valorAtual);
                  return (
                    <IMaskInput
                      mask={/^[0-9]{0,15}$/}
                      value={exibir}
                      onAccept={(val) => {
                        if (val === "") {
                          setFormValues((prev) => ({ ...prev, [nomeCampo]: "" }));
                          return;
                        }
                        const n = parseInt(val, 10);
                        setFormValues((prev) => ({ ...prev, [nomeCampo]: Number.isNaN(n) ? "" : n }));
                      }}
                      unmask={true}
                      inputMode="numeric"
                      placeholder={`Informe ${labelCampo} (somente inteiro)`}
                      className="form-control"
                      overwrite={true}
                    />
                  );
                }
                if (tipo === "decimal" || tipo === "valor") {
                  const valorAtualDecimal = formValues[nomeCampo];
                  const exibirDecimal = valorAtualDecimal === undefined || valorAtualDecimal === null ? "" : String(valorAtualDecimal);
                  return (
                    <IMaskInput
                      mask={Number}
                      scale={8}
                      min={0}
                      thousandsSeparator=""
                      radix="."
                      mapToRadix={[","]}
                      value={exibirDecimal}
                      onAccept={(val) => {
                        if (val === "" || val === undefined) {
                          setFormValues((prev) => ({ ...prev, [nomeCampo]: "" }));
                          return;
                        }
                        const n = Number(val);
                        setFormValues((prev) => ({ ...prev, [nomeCampo]: Number.isNaN(n) ? "" : n }));
                      }}
                      unmask={true}
                      inputMode="decimal"
                      placeholder={`Informe ${labelCampo} (decimal)`}
                      className="form-control"
                      overwrite={true}
                    />
                  );
                }
                if (tipo === "data") {
                  return (
                    <Data
                      value={formValues[nomeCampo] || ""}
                      onChange={(iso) =>
                        setFormValues((prev) => ({
                          ...prev,
                          [nomeCampo]: iso,
                        }))
                      }
                    />
                  );
                }
                const opcoesDoCampo = campoConfig.opcoes || opcoesCamposCustomizados[nomeCampo] || [];
                const isSelect = tipo === "select" || tipo === "cadastro" || (Array.isArray(opcoesDoCampo) && opcoesDoCampo.length > 0);
                if (isSelect && Array.isArray(opcoesDoCampo) && opcoesDoCampo.length > 0) {
                  const listaOpcoes = opcoesDoCampo
                    .slice()
                    .sort((a, b) => (Number(a.ordem) || 0) - (Number(b.ordem) || 0));
                  const valorAtual = formValues[nomeCampo];
                  return (
                    <Form.Select
                      value={valorAtual !== undefined && valorAtual !== null ? String(valorAtual) : ""}
                      onChange={(e) => {
                        const v = e.target.value;
                        const num = v === "" ? "" : Number(v);
                        setFormValues((prev) => ({ ...prev, [nomeCampo]: num === "" ? "" : num }));
                      }}
                    >
                      <option value="">Selecione</option>
                      {listaOpcoes.map((op) => (
                        <option key={op.id} value={op.id}>
                          {op.valor != null ? String(op.valor) : ""}
                        </option>
                      ))}
                    </Form.Select>
                  );
                }
                return (
                  <Form.Control
                    type="text"
                    value={formValues[nomeCampo] || ""}
                    onChange={(e) =>
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        [nomeCampo]: e.target.value,
                      }))
                    }
                    placeholder={`Informe ${labelCampo}`}
                  />
                );
              })()}
            </Form.Group>
          </Col>
        );
      });
  };

  //
  return (
    <>
    <Modal
      show={show}
      onHide={() => {
        setErroGeral(null);
        handleClose();
      }}
      backdrop="static"
      size="xl"
      dialogClassName="modal-dialog-top"
    >
      <Modal.Header closeButton className="dm-modal-header">
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600 }}>
          {documento ? "Documento" : "Adicionar Documento"}
          {documento?.id && (
            <span style={{ fontSize: "0.72rem", fontWeight: 400, color: "var(--text-muted)", marginLeft: 10 }}>
              #{documento.id}
            </span>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="dm-modal-body">
        <ErroModal erro={erroGeral} />

        {loadingCampos ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status" style={{ width: "2rem", height: "2rem" }}>
              <span className="visually-hidden">Carregando...</span>
            </div>
            <p className="mt-3 text-muted small">Carregando campos do documento...</p>
          </div>
        ) : (
        <>
        {/* 🔽 tudo que for impresso precisa estar aqui dentro */}
        <div className="print-root">
          <Form>
            <Row>
              <Col md={12}>
                <Form.Group controlId="id_tipo_documento">
                  <Form.Label>Tipo de Documento</Form.Label>
                  <div ref={tipoDocumentoComboboxRef}>
                  {!!formValues.id_tipo_documento ? (
                    <Form.Control
                      type="text"
                      readOnly
                      disabled
                      value={(() => {
                        const t = tiposDocumento.find((x) => String(x.id) === String(formValues.id_tipo_documento));
                        return t ? (t.descricao ? `${t.nome} (${t.descricao})` : t.nome) : "";
                      })()}
                      className="form-control"
                    />
                  ) : (
                    <div className="position-relative">
                      <div className="d-flex" style={{ alignItems: "stretch" }}>
                        <Form.Control
                          type="text"
                          placeholder="Pesquisar ou clique na seta para ver a lista..."
                          style={{ flex: "1 1 auto", minWidth: 0 }}
                          value={dropdownTipoDocumentoOpen ? searchTipoDocumento : ""}
                          onChange={(e) => {
                            setSearchTipoDocumento(e.target.value);
                            setDropdownTipoDocumentoOpen(true);
                          }}
                          onFocus={() => setDropdownTipoDocumentoOpen(true)}
                          autoComplete="off"
                          className="form-control"
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                          style={{
                            minWidth: "38px",
                            borderLeft: "1px solid #ced4da",
                            flexShrink: 0,
                            fontSize: "0.75rem",
                          }}
                          onClick={() => setDropdownTipoDocumentoOpen((v) => !v)}
                          title={dropdownTipoDocumentoOpen ? "Fechar lista" : "Ver lista"}
                          aria-label={dropdownTipoDocumentoOpen ? "Fechar lista" : "Ver lista"}
                        >
                          <span aria-hidden>{dropdownTipoDocumentoOpen ? "▲" : "▼"}</span>
                        </button>
                        <span
                          className="dm-select-add-combo-button-wrapper"
                          title={
                            permiteConfigurarTipoDocumento
                              ? "Adicionar tipo de documento"
                              : MENSAGEM_SEM_PERMISSAO_RECURSO
                          }
                        >
                          <button
                            type="button"
                            className="dm-select-add-combo-button"
                            onClick={abrirCadastroTipoDocumento}
                            disabled={!permiteConfigurarTipoDocumento}
                            aria-label="Adicionar tipo de documento"
                            title={permiteConfigurarTipoDocumento ? "Adicionar tipo de documento" : undefined}
                          >
                            <span className="dm-select-add-action-circle" aria-hidden="true" />
                          </button>
                        </span>
                      </div>
                      {dropdownTipoDocumentoOpen && (
                        <ul
                          className="list-group position-absolute w-100 mt-1 shadow-sm"
                          style={{ maxHeight: "240px", overflowY: "auto", zIndex: 1050 }}
                        >
                          {(() => {
                            const termo = (searchTipoDocumento || "").trim().toLowerCase();
                            const label = (t) => (t.descricao ? `${t.nome} (${t.descricao})` : t.nome);
                            const filtrados = termo
                              ? tiposDocumento.filter((t) => label(t).toLowerCase().includes(termo))
                              : tiposDocumento;
                            return filtrados.length === 0 ? (
                              <li className="list-group-item text-muted">Nenhum tipo encontrado</li>
                            ) : (
                              filtrados.map((tipo) => (
                                <li
                                  key={tipo.id}
                                  role="button"
                                  tabIndex={0}
                                  className="list-group-item list-group-item-action"
                                  onClick={() => selectTipoDocumentoById(tipo.id)}
                                  onKeyDown={(e) => e.key === "Enter" && selectTipoDocumentoById(tipo.id)}
                                >
                                  {tipo.descricao ? `${tipo.nome} (${tipo.descricao})` : tipo.nome}
                                </li>
                              ))
                            );
                          })()}
                        </ul>
                      )}
                    </div>
                  )}
                  </div>
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group controlId="id_empresa">
                  <Form.Label>Filial</Form.Label>
                  <Form.Select
                    value={formValues.id_empresa || ""}
                    onChange={handleEmpresaChange}
                    disabled={
                      !!formValues.id_empresa || !formValues.id_tipo_documento
                    }
                  >
                    <option value="">Selecione a filial</option>
                    {filiais.map((empresa) => (
                      <option key={empresa.id} value={empresa.id}>
                        {empresa.fantasia || empresa.razao_social}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {formValues.id_tipo_documento && formValues.id_empresa && (
              <Row>{renderCamposVisiveis()}</Row>
            )}
          </Form>
        </div>

        {/* Aditivo/Renovação de Documento (grid com 3 linhas e paginador) — só quando documento já está salvo */}
        {documento?.id && (
          <div className="mt-4 pt-2">
            <div className="dm-section-header">
              <FaFileSignature size={13} />
              <span>Aditivo / Renovação</span>
              <Button
                variant="outline-primary"
                size="sm"
                className="ms-auto"
                style={{ fontSize: "0.75rem", padding: "2px 10px", borderRadius: 20 }}
                onClick={handleOpenAditivosModal}
                title="Incluir novo aditivo/renovação"
              >
                + Novo
              </Button>
            </div>
            {aditivosLoading ? (
              <div className="d-flex align-items-center gap-2 py-3 text-muted small">
                <Spinner animation="border" size="sm" style={{ width: "1rem", height: "1rem" }} />
                <span>Carregando aditivos...</span>
              </div>
            ) : (
              <>
                <Table hover size="sm" className="mb-2 table-aditivos-modern border-0">
                  <thead>
                    <tr>
                      <th className="text-center">Aditivo/Renovação</th>
                      <th className="text-center">Data inicial</th>
                      <th className="text-center">Data vencimento</th>
                      <th className="text-center">Usuário</th>
                      <th className="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {aditivosPagina.length === 0 ? (
                      <tr>
                        <td colSpan={5} className="text-center text-muted small">Nenhum aditivo registrado.</td>
                      </tr>
                    ) : (
                      aditivosPagina.map((a) => {
                        const isMaisRecente = listaAditivosOrdenados[0]?.id === a.id;
                        return (
                          <tr key={a.id}>
                            <td className="text-center">{(a.numero_aditivo === 0 || a.numero_aditivo === "0") ? "Original" : a.numero_aditivo}</td>
                            <td className="text-center">{formatarData(a.dt_inicial)}</td>
                            <td className="text-center">{formatarData(a.dt_vencimento)}</td>
                            <td className="text-center">{a.nome_usuario || "—"}</td>
                            <td className="text-center">
                              <Button
                                variant="light"
                                size="sm"
                                className="p-1 me-1 modal-footer-btn-acao btn-acao-arquivo"
                                title="Gerenciar anexo do aditivo"
                                onClick={() => handleClickAnexoAditivo(a)}
                              >
                                <FaPaperclip size={14} style={(a.tem_anexo || a.nome_anexo) ? { color: "var(--gd-green-500)" } : undefined} />
                              </Button>
                              {isMaisRecente && (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  className="p-1 me-1"
                                  title="Editar aditivo"
                                  onClick={() => handleOpenEditarAditivo(a)}
                                >
                                  <FaEdit size={14} />
                                </Button>
                              )}
                              {isMaisRecente && (a.numero_aditivo !== 0 && a.numero_aditivo !== "0") && (
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  className="p-1"
                                  title="Excluir aditivo"
                                  onClick={() => handleExcluirAditivo(a.id)}
                                >
                                  <FaTrash size={14} />
                                </Button>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    {totalRecordsAditivos > 0 && (
                      <span className="text-muted small">
                        Mostrando {startRecordAditivos} a {endRecordAditivos} de {totalRecordsAditivos} registros
                      </span>
                    )}
                  </div>
                  {totalPagesAditivos > 1 && (
                    <Pagination size="sm" className="mb-0">
                      <Pagination.First
                        onClick={() => handleChangePageAditivos(1)}
                        disabled={pageAtualAditivos === 1}
                      />
                      <Pagination.Prev
                        onClick={() => handleChangePageAditivos(pageAtualAditivos - 1)}
                        disabled={pageAtualAditivos === 1}
                      />
                      {[...Array(totalPagesAditivos)].map((_, index) => {
                        const pageNum = index + 1;
                        if (
                          pageNum === 1 ||
                          pageNum === totalPagesAditivos ||
                          (pageNum >= pageAtualAditivos - 1 && pageNum <= pageAtualAditivos + 1)
                        ) {
                          return (
                            <Pagination.Item
                              key={pageNum}
                              active={pageNum === pageAtualAditivos}
                              onClick={() => handleChangePageAditivos(pageNum)}
                            >
                              {pageNum}
                            </Pagination.Item>
                          );
                        }
                        if (pageNum === 2 && pageAtualAditivos > 3) {
                          return <Pagination.Ellipsis key="ellipsis-start" disabled />;
                        }
                        if (pageNum === totalPagesAditivos - 1 && pageAtualAditivos < totalPagesAditivos - 2) {
                          return <Pagination.Ellipsis key="ellipsis-end" disabled />;
                        }
                        return null;
                      })}
                      <Pagination.Next
                        onClick={() => handleChangePageAditivos(pageAtualAditivos + 1)}
                        disabled={pageAtualAditivos === totalPagesAditivos}
                      />
                      <Pagination.Last
                        onClick={() => handleChangePageAditivos(totalPagesAditivos)}
                        disabled={pageAtualAditivos === totalPagesAditivos}
                      />
                    </Pagination>
                  )}
                </div>
              </>
            )}
          </div>
        )}
        </>
        )}
      </Modal.Body>

      <Modal.Footer className="modal-footer-padrao dm-modal-footer">
        <div className="modal-footer-acoes-esquerda">
          {formValues.id_tipo_documento && (
            <>
              <Button
                variant="light"
                size="sm"
                className="modal-footer-btn-acao btn-acao-notificacao"
                onClick={handleOpenUsuariosModal}
                title="Usuários para notificação"
              >
                <FaUserFriends size={18} />
              </Button>
              {permiteConfigurarTipoDocumento && (
                <Button
                  variant="light"
                  size="sm"
                  className="modal-footer-btn-acao btn-acao-config"
                  onClick={handleOpenConfigCamposTipoDocumento}
                  title="Configurações de Campos"
                >
                  <FaCog size={18} />
                </Button>
              )}
              {permiteConfigurarTipoDocumento && (
              <Button
                variant="light"
                size="sm"
                className="modal-footer-btn-acao btn-acao-agenda"
                onClick={handleOpenTipoDocumentoTiposAgendamentoModal}
                title="Vincular tipos de agendamento ao tipo de documento"
              >
                <FaClock size={18} />
              </Button>
              )}
              <Button
                variant="light"
                size="sm"
                className="modal-footer-btn-acao btn-acao-agenda"
                onClick={handleOpenAgendamentosModal}
                title="Agendamentos"
              >
                <FaCalendarAlt size={18} />
              </Button>
              <Button
                variant="light"
                size="sm"
                className="modal-footer-btn-acao btn-acao-arquivo"
                onClick={handlePrint}
                title="Imprimir"
              >
                <FaPrint size={18} />
              </Button>
            </>
          )}
          {formValues.id_tipo_documento && (
            <Button
              variant="light"
              size="sm"
              className="modal-footer-btn-acao btn-acao-arquivo"
              onClick={handleClickAnexo}
              title={documento?.id && documentoTemAnexo() ? "Visualizar anexo" : "Gerenciar anexo"}
            >
              <FaPaperclip size={18} style={documentoTemAnexo() ? { color: "var(--gd-green-500)" } : undefined} />
            </Button>
          )}
        </div>
        <div className="modal-footer-acoes-direita">
          <Cancelar
            onClick={() => {
              setErroGeral(null);
              handleClose();
            }}
          />
          <Salvar onClick={handleSave} />
        </div>
      </Modal.Footer>

      {/* Modal: seleção de usuários */}
      <Modal
        show={showUsuariosModal}
        onHide={() => setShowUsuariosModal(false)}
        dialogClassName="modal-dialog-top"
        size="lg"
      >
        <Modal.Header closeButton className="dm-modal-header">
          <Modal.Title>Selecionar Usuários para Notificação</Modal.Title>
        </Modal.Header>
        <Modal.Body className="dm-modal-body">
          {(() => {
            const totalRecords = listaUsuariosFiltrada.length;
            const totalPages = Math.ceil(totalRecords / USUARIOS_NOTIFICACAO_ITEMS_PER_PAGE) || 1;
            const startRecord = totalRecords === 0 ? 0 : (pageAtualUsuarios - 1) * USUARIOS_NOTIFICACAO_ITEMS_PER_PAGE + 1;
            const endRecord = Math.min(pageAtualUsuarios * USUARIOS_NOTIFICACAO_ITEMS_PER_PAGE, totalRecords);
            const inicio = (pageAtualUsuarios - 1) * USUARIOS_NOTIFICACAO_ITEMS_PER_PAGE;
            const usuariosPagina = listaUsuariosFiltrada.slice(inicio, inicio + USUARIOS_NOTIFICACAO_ITEMS_PER_PAGE);
            const handleChangePageUsuarios = (page) => setPageAtualUsuarios(page);
            return (
              <>
                <div className="dm-document-scope-note" role="note">
                  <strong>Exclusivo deste documento.</strong> Esta selecao define quem sera notificado apenas aqui e nao altera os usuarios vinculados ao tipo de agendamento ou as configuracoes globais.
                </div>
                <Form.Group controlId="searchUsuarios" className="mb-3">
                  <Form.Label>Pesquisar Usuários</Form.Label>
                  <Form.Control
                    type="text"
                    value={searchTerm}
                    placeholder="Digite para pesquisar..."
                    onChange={(e) => handleSearchChange(e.target.value)}
                  />
                </Form.Group>
                <div style={{ maxHeight: "400px", overflowY: "auto", padding: "12px 4px" }} className="mb-3">
                  {usuariosPagina.length === 0 ? (
                    <p className="text-muted text-center py-4">Nenhum usuário encontrado.</p>
                  ) : (
                    <Table striped bordered hover size="sm" className="mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: "80px", textAlign: "center" }}>Notificar</th>
                          <th>Usuário</th>
                        </tr>
                      </thead>
                      <tbody>
                        {usuariosPagina.map((usuario) => (
                          <tr key={usuario.id}>
                            <td className="align-middle text-center">
                              <Form.Check
                                type="switch"
                                id={`usuario-notif-${usuario.id}`}
                                checked={usuariosNotificacao.includes(usuario.id)}
                                onChange={() => handleUserClick(usuario.id)}
                                style={{ cursor: "pointer" }}
                              />
                            </td>
                            <td className="align-middle" style={{ cursor: "pointer" }} onClick={() => handleUserClick(usuario.id)}>
                              {usuario.nome}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    {totalRecords > 0 && (
                      <span className="text-muted small">
                        Mostrando {startRecord} a {endRecord} de {totalRecords} registros
                      </span>
                    )}
                  </div>
                  {totalPages > 1 && (
                    <Pagination size="sm" className="mb-0">
                      <Pagination.First
                        onClick={() => handleChangePageUsuarios(1)}
                        disabled={pageAtualUsuarios === 1}
                      />
                      <Pagination.Prev
                        onClick={() => handleChangePageUsuarios(pageAtualUsuarios - 1)}
                        disabled={pageAtualUsuarios === 1}
                      />
                      {[...Array(totalPages)].map((_, index) => {
                        const pageNum = index + 1;
                        if (
                          pageNum === 1 ||
                          pageNum === totalPages ||
                          (pageNum >= pageAtualUsuarios - 1 && pageNum <= pageAtualUsuarios + 1)
                        ) {
                          return (
                            <Pagination.Item
                              key={pageNum}
                              active={pageNum === pageAtualUsuarios}
                              onClick={() => handleChangePageUsuarios(pageNum)}
                            >
                              {pageNum}
                            </Pagination.Item>
                          );
                        }
                        if (pageNum === 2 && pageAtualUsuarios > 3) {
                          return <Pagination.Ellipsis key="ellipsis-start" disabled />;
                        }
                        if (pageNum === totalPages - 1 && pageAtualUsuarios < totalPages - 2) {
                          return <Pagination.Ellipsis key="ellipsis-end" disabled />;
                        }
                        return null;
                      })}
                      <Pagination.Next
                        onClick={() => handleChangePageUsuarios(pageAtualUsuarios + 1)}
                        disabled={pageAtualUsuarios === totalPages}
                      />
                      <Pagination.Last
                        onClick={() => handleChangePageUsuarios(totalPages)}
                        disabled={pageAtualUsuarios === totalPages}
                      />
                    </Pagination>
                  )}
                </div>
              </>
            );
          })()}
        </Modal.Body>
        <Modal.Footer className="modal-footer-padrao dm-modal-footer">
          <div className="modal-footer-acoes-esquerda" />
          <div className="modal-footer-acoes-direita">
            <Cancelar onClick={() => setShowUsuariosModal(false)} />
            <Salvar onClick={handleSaveUsuarios} title="Salvar Seleção" />
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal: Novo aditivo / Editar aditivo (mesmo formulário) */}
      <Modal
        show={showAditivosModal}
        onHide={() => {
          setShowAditivosModal(false);
          setFormAditivo({ dt_inicial: "", dt_vencimento: "", nr_dias_aviso: "", observacao: "", status: "Vigente" });
          setAditivoEditando(null);
          setSelectedFileNovoAditivo(null);
          setErroAditivo(null);
        }}
        size="lg"
        dialogClassName="modal-dialog-top"
      >
        <Modal.Header closeButton className="dm-modal-header">
          <Modal.Title>{aditivoEditando ? "Editar aditivo" : "Novo aditivo"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="dm-modal-body">
          {erroAditivo && (
            <div className="alert alert-danger py-2" role="alert">
              {erroAditivo}
            </div>
          )}
          {aditivosLoading ? (
            <div className="text-center py-4">
              <Spinner animation="border" size="sm" /> Carregando...
            </div>
          ) : (() => {
            const ordenadosAditivos = [...listaAditivos].sort((a, b) => (b.numero_aditivo || 0) - (a.numero_aditivo || 0));
            const ultimoAditivo = ordenadosAditivos[0];
            const minDataInicialAditivo = aditivoEditando ? "" : (ultimoAditivo?.dt_vencimento
              ? parseDDMMYYYYToMySQL(dataMaisUmDia(ultimoAditivo.dt_vencimento))
              : "");
            return (
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small">
                      Data inicial{!aditivoEditando && <span className="text-danger"> *</span>}
                    </Form.Label>
                    <Data
                      className="form-control form-control-sm"
                      value={formAditivo.dt_inicial || ""}
                      onChange={(iso) => setFormAditivo((p) => ({ ...p, dt_inicial: iso }))}
                      disabled={aditivoSalvando}
                    />
                    {!aditivoEditando && minDataInicialAditivo && (
                      <Form.Text className="text-muted small">A partir do dia seguinte ao vencimento do último aditivo</Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small">
                      Data vencimento{!aditivoEditando && <span className="text-danger"> *</span>}
                    </Form.Label>
                    <Data
                      className="form-control form-control-sm"
                      value={formAditivo.dt_vencimento || ""}
                      onChange={(iso) => setFormAditivo((p) => ({ ...p, dt_vencimento: iso }))}
                      disabled={aditivoSalvando}
                    />
                    {formAditivo.dt_inicial && (
                      <Form.Text className="text-muted small">Não pode ser anterior à data inicial</Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small">Observação</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={formAditivo.observacao}
                      onChange={(e) => setFormAditivo((p) => ({ ...p, observacao: e.target.value }))}
                      placeholder="Opcional"
                      className="form-control-sm"
                    />
                  </Form.Group>
                </Col>
              </Row>
              {aditivoEditando && (
                <Form.Text className="text-muted small">Informe ao menos uma das datas para atualizar. Apenas os campos alterados serão enviados.</Form.Text>
              )}
            </Form>
            );
          })()}
        </Modal.Body>
        <input
          ref={inputFileNovoAditivoRef}
          type="file"
          accept="application/pdf"
          style={{ display: "none" }}
          onChange={handleAnexoNovoAditivoChange}
        />
        <Modal.Footer className="modal-footer-padrao dm-modal-footer">
          <div className="modal-footer-acoes-esquerda">
            {aditivoEditando ? (
              <Button
                variant="light"
                size="sm"
                className="modal-footer-btn-acao btn-acao-arquivo"
                onClick={() => handleClickAnexoAditivo(aditivoEditando)}
                title="Gerenciar anexo do aditivo"
              >
                <FaPaperclip size={18} style={aditivoEditando?.nome_anexo ? { color: "var(--gd-green-500)" } : undefined} />
              </Button>
            ) : (
              <>
                <Button
                  variant="light"
                  size="sm"
                  className="modal-footer-btn-acao btn-acao-arquivo"
                  onClick={() => inputFileNovoAditivoRef.current?.click()}
                  title="Anexar PDF ao aditivo (opcional)"
                >
                  <FaPaperclip size={18} style={selectedFileNovoAditivo ? { color: "var(--gd-green-500)" } : undefined} />
                </Button>
                {selectedFileNovoAditivo && (
                  <span className="align-self-center ms-2 text-muted small" style={{ maxWidth: "180px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={selectedFileNovoAditivo.name}>
                    {selectedFileNovoAditivo.name}
                  </span>
                )}
              </>
            )}
          </div>
          <div className="modal-footer-acoes-direita">
            <Cancelar
              onClick={() => {
                setShowAditivosModal(false);
                setFormAditivo({ dt_inicial: "", dt_vencimento: "", nr_dias_aviso: "", observacao: "", status: "Vigente" });
                setAditivoEditando(null);
                setSelectedFileNovoAditivo(null);
                setErroAditivo(null);
              }}
            />
            <Salvar
              onClick={aditivoEditando ? handleSaveEditarAditivo : handleSaveAditivo}
              loading={aditivoSalvando}
              disabled={aditivosLoading}
              title={aditivoEditando ? "Salvar" : "Registrar aditivo"}
            />
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal: visualização de agendamentos */}
      <Modal
        show={showAgendamentosModal}
        onHide={() => setShowAgendamentosModal(false)}
        size="xl"
        dialogClassName="modal-dialog-top"
      >
        <Modal.Header closeButton className="dm-modal-header">
          <div className="d-flex align-items-center gap-3">
            <Modal.Title>Agendamentos Configurados</Modal.Title>
            {!loadingAgendamentos && agendamentoDetalhes.length > 0 && (
              <Form.Check
                type="checkbox"
                id="filtro-pendentes-modal"
                label="Pendentes"
                checked={pendentesOnly}
                onChange={(e) => { setPendentesOnly(e.target.checked); setAgendamentosPage(1); }}
                className="mb-0"
              />
            )}
          </div>
        </Modal.Header>
        <Modal.Body className="dm-modal-body">
          {loadingAgendamentos ? (
            <div className="d-flex justify-content-center align-items-center py-4">
              <Spinner animation="border" size="sm" className="me-2" />
              <span>Carregando agendamentos...</span>
            </div>
          ) : agendamentoDetalhes.length === 0 ? (
            <div className="text-center p-4">
              <i className="far fa-clock fa-3x mb-3 text-muted"></i>
              <p>Nenhum agendamento gerado para este documento.</p>
              <p className="text-muted small">
                Acesse a tela de <strong>Agendamentos</strong> e clique em <strong>Gerar Agendamentos</strong>.
              </p>
            </div>
          ) : (() => {
            const agFiltrados = agendamentoDetalhes
              .filter((r) => !pendentesOnly || r.situacao === "P")
              .sort((a, b) => {
                const da = a.data_proxima_execucao ? new Date(a.data_proxima_execucao).getTime() : 0;
                const db = b.data_proxima_execucao ? new Date(b.data_proxima_execucao).getTime() : 0;
                return db - da;
              });
            const PAGE_SIZE = 10;
            const totalPages = Math.max(1, Math.ceil(agFiltrados.length / PAGE_SIZE));
            const pagina = agFiltrados.slice(
              (agendamentosPage - 1) * PAGE_SIZE,
              agendamentosPage * PAGE_SIZE
            );
            return (
              <>
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Periodicidade</th>
                      <th>Data Execução</th>
                      <th>Situação</th>
                      <th>Emails</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pagina.length === 0 ? (
                      <tr>
                        <td colSpan={5} className="text-center text-muted py-3">
                          Nenhum agendamento pendente.
                        </td>
                      </tr>
                    ) : (
                      pagina.map((row, idx) => {
                        const periodicidadeDesc = getDescricaoPeriodicidade
                          ? getDescricaoPeriodicidade(row.periodicidade)
                          : row.periodicidade;

                        let dataExecucao = "—";
                        if (row.data_proxima_execucao) {
                          try {
                            dataExecucao = new Date(row.data_proxima_execucao).toLocaleString("pt-BR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            });
                          } catch {
                            dataExecucao = row.data_proxima_execucao;
                          }
                        }

                        const situacaoBadge =
                          row.situacao === "P" ? (
                            <Badge bg="warning" text="dark">Pendente</Badge>
                          ) : row.situacao === "E" ? (
                            <Badge bg="success">Executado</Badge>
                          ) : (
                            <span className="text-muted">—</span>
                          );

                        return (
                          <tr key={idx}>
                            <td>{row.nome}</td>
                            <td>{periodicidadeDesc}</td>
                            <td>{dataExecucao}</td>
                            <td>{situacaoBadge}</td>
                            <td>
                              {row.emails && row.emails.length > 0 ? (
                                row.emails.map((e, i) => <div key={i}>{e}</div>)
                              ) : (
                                <span className="text-muted">Sem e-mails</span>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-2">
                    <Pagination size="sm">
                      <Pagination.First onClick={() => setAgendamentosPage(1)} disabled={agendamentosPage === 1} />
                      <Pagination.Prev onClick={() => setAgendamentosPage((p) => Math.max(1, p - 1))} disabled={agendamentosPage === 1} />
                      {Array.from({ length: totalPages }, (_, i) => (
                        <Pagination.Item
                          key={i + 1}
                          active={agendamentosPage === i + 1}
                          onClick={() => setAgendamentosPage(i + 1)}
                        >
                          {i + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next onClick={() => setAgendamentosPage((p) => Math.min(totalPages, p + 1))} disabled={agendamentosPage === totalPages} />
                      <Pagination.Last onClick={() => setAgendamentosPage(totalPages)} disabled={agendamentosPage === totalPages} />
                    </Pagination>
                  </div>
                )}
              </>
            );
          })()}
        </Modal.Body>
        <Modal.Footer className="modal-footer-padrao dm-modal-footer">
          <div className="modal-footer-acoes-esquerda" />
          <div className="modal-footer-acoes-direita">
            <Cancelar onClick={() => setShowAgendamentosModal(false)} title="Fechar" />
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal: seleção de documentos tipos agendamento */}
      <Modal
        show={showDocumentosTiposAgendamentoModal}
        onHide={() => setShowDocumentosTiposAgendamentoModal(false)}
        dialogClassName="modal-dialog-top"
        size="lg"
      >
        <Modal.Header closeButton className="dm-modal-header">
          <Modal.Title>
            Vincular Tipos de Agendamento
            {selectedTipoParaAgendamento && (
              <span style={{ display: "block", fontSize: "0.82rem", fontWeight: 400, color: "var(--text-muted)", marginTop: 2 }}>
                {selectedTipoParaAgendamento.nome}
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="dm-modal-body">
          {(() => {
            const listaTiposAtivos = tiposAgendamentoDisponiveis.filter((a) => a.situacao === "A");
            const termo = (searchTermTiposAgendamento || "").trim().toLowerCase();
            const listaTiposFiltrada = termo
              ? listaTiposAtivos.filter(
                  (a) =>
                    (a.nome || "").toLowerCase().includes(termo) ||
                    (a.descricao || "").toLowerCase().includes(termo)
                )
              : listaTiposAtivos;
            const totalRecords = listaTiposFiltrada.length;
            const totalPages = Math.ceil(totalRecords / TIPOS_AGENDAMENTO_ITEMS_PER_PAGE) || 1;
            const startRecord = totalRecords === 0 ? 0 : (pageAtualTiposAgendamento - 1) * TIPOS_AGENDAMENTO_ITEMS_PER_PAGE + 1;
            const endRecord = Math.min(pageAtualTiposAgendamento * TIPOS_AGENDAMENTO_ITEMS_PER_PAGE, totalRecords);
            const inicio = (pageAtualTiposAgendamento - 1) * TIPOS_AGENDAMENTO_ITEMS_PER_PAGE;
            const tiposPagina = listaTiposFiltrada.slice(inicio, inicio + TIPOS_AGENDAMENTO_ITEMS_PER_PAGE);
            const handleChangePageTipos = (page) => setPageAtualTiposAgendamento(page);
            const getDescricaoPeriodicidadeLocal = (p) => {
              switch (p) {
                case "D": return "Diário";
                case "S": return "Semanal";
                case "M": return "Mensal";
                case "A": return "Anual";
                case "V": return "Dias Antes do Vencimento";
                case "VD": return "Dias Antes do Vencimento (Pelo Documento)";
                default: return "Outro";
              }
            };
            return (
              <>
                <Form.Group controlId="searchTiposAgendamento" className="mb-3">
                  <Form.Label>Pesquisar Tipos de Agendamento</Form.Label>
                  <Form.Control
                    type="text"
                    value={searchTermTiposAgendamento}
                    placeholder="Digite para pesquisar..."
                    onChange={(e) => {
                      setSearchTermTiposAgendamento(e.target.value);
                      setPageAtualTiposAgendamento(1);
                    }}
                  />
                </Form.Group>
                <div style={{ maxHeight: "400px", overflowY: "auto", padding: "12px 4px" }} className="mb-3">
                  {tiposPagina.length === 0 ? (
                    <p className="text-muted text-center py-4">Nenhum tipo de agendamento encontrado.</p>
                  ) : (
                    <Table striped bordered hover size="sm" className="mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: "80px", textAlign: "center" }}>Selecionar</th>
                          <th>Nome</th>
                          <th>Descrição / Periodicidade</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tiposPagina.map((agendamento) => (
                          <tr key={agendamento.id}>
                            <td className="align-middle text-center">
                              <Form.Check
                                type="switch"
                                id={`tipo-agendamento-${agendamento.id}`}
                                checked={tiposAgendamentoSelecionados.includes(agendamento.id)}
                                onChange={() => handleTipoAgendamentoClick(agendamento.id)}
                                style={{ cursor: "pointer" }}
                              />
                            </td>
                            <td className="align-middle" style={{ cursor: "pointer" }} onClick={() => handleTipoAgendamentoClick(agendamento.id)}>
                              <strong>{agendamento.nome}</strong>
                            </td>
                            <td className="align-middle" style={{ cursor: "pointer", fontSize: "0.9rem" }} onClick={() => handleTipoAgendamentoClick(agendamento.id)}>
                              {agendamento.descricao && <span>{agendamento.descricao}</span>}
                              {agendamento.descricao && <br />}
                              <span className="text-muted">
                                {getDescricaoPeriodicidadeLocal(agendamento.periodicidade)}
                                {" - "}
                                {agendamento.horario || "08:00"}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    {totalRecords > 0 && (
                      <span className="text-muted small">
                        Mostrando {startRecord} a {endRecord} de {totalRecords} registros
                      </span>
                    )}
                  </div>
                  {totalPages > 1 && (
                    <Pagination size="sm" className="mb-0">
                      <Pagination.First
                        onClick={() => handleChangePageTipos(1)}
                        disabled={pageAtualTiposAgendamento === 1}
                      />
                      <Pagination.Prev
                        onClick={() => handleChangePageTipos(pageAtualTiposAgendamento - 1)}
                        disabled={pageAtualTiposAgendamento === 1}
                      />
                      {[...Array(totalPages)].map((_, index) => {
                        const pageNum = index + 1;
                        if (
                          pageNum === 1 ||
                          pageNum === totalPages ||
                          (pageNum >= pageAtualTiposAgendamento - 1 && pageNum <= pageAtualTiposAgendamento + 1)
                        ) {
                          return (
                            <Pagination.Item
                              key={pageNum}
                              active={pageNum === pageAtualTiposAgendamento}
                              onClick={() => handleChangePageTipos(pageNum)}
                            >
                              {pageNum}
                            </Pagination.Item>
                          );
                        }
                        if (pageNum === 2 && pageAtualTiposAgendamento > 3) {
                          return <Pagination.Ellipsis key="ellipsis-start" disabled />;
                        }
                        if (pageNum === totalPages - 1 && pageAtualTiposAgendamento < totalPages - 2) {
                          return <Pagination.Ellipsis key="ellipsis-end" disabled />;
                        }
                        return null;
                      })}
                      <Pagination.Next
                        onClick={() => handleChangePageTipos(pageAtualTiposAgendamento + 1)}
                        disabled={pageAtualTiposAgendamento === totalPages}
                      />
                      <Pagination.Last
                        onClick={() => handleChangePageTipos(totalPages)}
                        disabled={pageAtualTiposAgendamento === totalPages}
                      />
                    </Pagination>
                  )}
                </div>
              </>
            );
          })()}
        </Modal.Body>
        <Modal.Footer className="modal-footer-padrao dm-modal-footer">
          <div className="modal-footer-acoes-esquerda" />
          <div className="modal-footer-acoes-direita">
            <Cancelar onClick={() => setShowDocumentosTiposAgendamentoModal(false)} />
            <Salvar onClick={handleSaveTipoDocumentoTiposAgendamento} title="Salvar Vínculos" />
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal: Gerenciar Anexo */}
      <Modal
        show={showArquivoModal}
        onHide={() => {
          setShowArquivoModal(false);
          setErroArquivo(null);
        }}
        dialogClassName="modal-dialog-top"
      >
        <Modal.Header closeButton className="dm-modal-header">
          <Modal.Title>Gerenciar Anexo</Modal.Title>
        </Modal.Header>

        <Modal.Body className="dm-modal-body">
          {anexoAtual?.nome ? (
            <div className="border rounded px-3 py-2 dm-anexo-block">
              <div className="d-flex align-items-center">
                <Button
                  variant="link"
                  className="text-primary text-decoration-none flex-grow-1 text-start p-0"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  onClick={abrirVisualizadorPdfDocumento}
                  title="Visualizar PDF"
                >
                  {anexoAtual.nome}
                </Button>
              <Button
                variant="outline-danger"
                size="sm"
                className="p-1 ms-2"
                onClick={handleExcluirArquivo}
                aria-label="Remover anexo"
                title="Remover Anexo"
              >
                <FaTrash size={14} />
              </Button>
              </div>
            </div>
          ) : (
            <Form.Group controlId="uploadArquivoBase64">
              <Form.Label>
                Enviar novo arquivo (PDF até {tamanhoMaximoArquivoMB} MB)
              </Form.Label>
              <Form.Control
                type="file"
                onChange={handleArquivoChange}
                accept="application/pdf"
              />
              {erroArquivo && (
                <div className="text-danger mt-2">{erroArquivo}</div>
              )}
            </Form.Group>
          )}
        </Modal.Body>

        {!anexoAtual?.nome && (
          <Modal.Footer className="modal-footer-padrao dm-modal-footer">
            <div className="modal-footer-acoes-esquerda" />
            <div className="modal-footer-acoes-direita">
              {documento?.id ? (
                <Button variant="success" className="modal-footer-btn-salvar" onClick={handleUploadArquivo} title="Upload">
                  <FaSave size={18} />
                </Button>
              ) : (
                <Button
                  variant="success"
                  className="modal-footer-btn-salvar"
                  onClick={() => {
                    setShowArquivoModal(false);
                    setErroArquivo(null);
                  }}
                  title="O arquivo será enviado ao salvar o documento"
                >
                  <FaSave size={18} />
                </Button>
              )}
            </div>
          </Modal.Footer>
        )}
      </Modal>

      {/* Modal: Gerenciar Anexo do Aditivo */}
      <Modal
        show={showAnexoAditivoModal}
        onHide={handleCloseAnexoAditivoModal}
        size="sm"
        dialogClassName="modal-dialog-top"
      >
        <Modal.Header closeButton className="dm-modal-header">
          <Modal.Title>Gerenciar Anexo — Aditivo {aditivoAnexoSelecionado?.numero_aditivo != null ? ((aditivoAnexoSelecionado.numero_aditivo === 0 || aditivoAnexoSelecionado.numero_aditivo === "0") ? "Original" : `#${aditivoAnexoSelecionado.numero_aditivo}`) : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="dm-modal-body">
          {erroArquivoAditivo && (
            <div className="alert alert-danger py-2" role="alert">
              {erroArquivoAditivo}
            </div>
          )}
          {aditivoAnexoSelecionado?.nome_anexo ? (
            <div className="border rounded px-3 py-2 dm-anexo-block">
              <div className="d-flex align-items-center">
                <Button
                  variant="link"
                  className="text-primary text-decoration-none flex-grow-1 text-start p-0"
                  style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                  onClick={() => abrirVisualizadorPdfAditivo(aditivoAnexoSelecionado)}
                  title="Visualizar PDF"
                >
                  {aditivoAnexoSelecionado.nome_anexo}
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="p-1 ms-2"
                  onClick={handleExcluirArquivoAditivo}
                  disabled={anexoAditivoUploading}
                  title="Remover anexo"
                >
                  <FaTrash size={14} />
                </Button>
              </div>
            </div>
          ) : (
            <Form.Group controlId="uploadArquivoAditivo">
              <Form.Label>Enviar arquivo (PDF até {tamanhoMaximoArquivoMB} MB)</Form.Label>
              <Form.Control
                type="file"
                onChange={handleArquivoChangeAditivo}
                accept="application/pdf"
              />
            </Form.Group>
          )}
        </Modal.Body>
        {!aditivoAnexoSelecionado?.nome_anexo && (
          <Modal.Footer className="modal-footer-padrao dm-modal-footer">
            <Cancelar onClick={handleCloseAnexoAditivoModal} />
            <Salvar
              onClick={handleUploadArquivoAditivo}
              loading={anexoAditivoUploading}
              disabled={!selectedFileAditivo}
              title="Upload"
            />
          </Modal.Footer>
        )}
      </Modal>

      {/* Visualizador de PDF (anexo documento / aditivo) */}
      <PdfViewerModal
        show={pdfViewerAnexo.show}
        onHide={fecharVisualizadorPdf}
        documentoId={pdfViewerAnexo.documentoId}
        aditivoId={pdfViewerAnexo.aditivoId}
        title={pdfViewerAnexo.title}
        onExcluir={handleExcluirAnexoVisualizador}
      />

      {/* Modal de pré-visualização PDF (mesmo fluxo de Documentos.js) */}
      <Modal
        show={showPdfPreview}
        onHide={() => setShowPdfPreview(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton className="dm-modal-header">
          <Modal.Title>Pré Visualização PDF</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 dm-modal-body" style={{ minHeight: "70vh" }}>
          {pdfPreviewLoading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner animation="border" />
            </div>
          ) : pdfPreviewHtml ? (
            <iframe
              ref={pdfIframeRef}
              title="Pré Visualização PDF"
              srcDoc={pdfPreviewHtml}
              style={{ width: "100%", height: "70vh", border: "none" }}
            />
          ) : (
            <div className="text-center text-muted py-5">Nenhum conteúdo para exibir.</div>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer-padrao dm-modal-footer">
          <div className="modal-footer-acoes-esquerda" />
          <div className="modal-footer-acoes-direita">
            <Button
              variant="success"
              className="modal-footer-btn-salvar"
              onClick={() => pdfIframeRef.current?.contentWindow?.print()}
              disabled={!pdfPreviewHtml}
            >
              Imprimir
            </Button>
            <Cancelar onClick={() => setShowPdfPreview(false)} title="Fechar" />
          </div>
        </Modal.Footer>
      </Modal>
    </Modal>
      <ConfiguracoesCamposModal
        show={showConfigCamposModal}
        handleClose={handleCloseConfigCamposTipoDocumento}
        configuracao={selectedTipoForConfig}
        fetchConfiguracoes={() => {
          if (formValues.id_tipo_documento && formValues.id_empresa) {
            fetchCamposConfigurados(formValues.id_tipo_documento, formValues.id_empresa);
          }
        }}
      />
      <TiposPagamentoModal
        show={showTipoPagamentoModal}
        handleClose={() => setShowTipoPagamentoModal(false)}
        tipoPagamento={null}
        fetchTiposPagamento={recarregarTiposPagamento}
      />
      <TiposDocumentoModal
        show={showTipoDocumentoModal}
        handleClose={handleCloseTipoDocumentoModal}
        documento={null}
        idEntidade={entidadeID}
        fetchTiposDocumento={() => recarregarTiposDocumento()}
      />
      <IndicesCorrecaoModal
        show={showIndiceCorrecaoModal}
        handleClose={() => setShowIndiceCorrecaoModal(false)}
        indice={null}
        fetchIndicesCorrecao={recarregarIndicesCorrecao}
      />
      <EmpresasModal
        show={showFornecedorModal}
        handleClose={handleCloseFornecedorModal}
        empresa={null}
        fetchEmpresas={recarregarFornecedores}
        classificacaoOverride="F"
      />
      <FuncionariosModal
        show={showFuncionarioModal}
        handleClose={() => setShowFuncionarioModal(false)}
        funcionario={null}
        fetchFuncionarios={recarregarFuncionarios}
        defaultEmpresaId={formValues.id_fornecedor || ""}
      />
    </>
  );
};

export default DocumentosModal;
